<template>
  <SidebarComponent />
  <div class="dashboard-layout staff-top-page">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card staff-top-heading">
          <h1>Utenti TOP</h1>
          <p>Percorsi, check e contatti in un’unica vista.</p>
        </div>

        <section class="toolbar-card card-surface staff-top-filters-panel">
          <div class="filters-header">
            <button
              type="button"
              class="accordion-toggle"
              v-staff-top-tooltip="filtersOpen ? 'Nasconde i filtri senza cambiare la selezione.' : 'Mostra ricerca, filtri e azioni della lista TOP.'"
              @click="filtersOpen = !filtersOpen"
              :aria-expanded="filtersOpen"
              aria-controls="staff-top-filters"
            >
              <div class="toggle-copy">
                <span class="toggle-title">Filtri e azioni</span>
                <span class="toggle-subtitle">Organizza la lista e affina i risultati.</span>
              </div>
              <span class="material-icons" aria-hidden="true">
                {{ filtersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </button>
          </div>

          <transition name="accordion">
            <div v-show="filtersOpen" id="staff-top-filters" class="accordion-panel staff-top-filter-body">
              <div class="staff-top-filter-view-row">
                <span id="staff-top-view-label" class="staff-top-filter-label">Vista</span>
                <div class="summary-pills staff-top-view-options" role="group" aria-labelledby="staff-top-view-label">
                  <button
                    type="button"
                    class="summary-pill summary-pill--clickable summary-pill--active-users"
                    :class="{ 'summary-pill--active': topListView === 'active' }"
                    :aria-pressed="topListView === 'active'"
                    v-staff-top-tooltip="topControlHelp.active"
                    @click="setTopListView('active')"
                  >
                    <span>TOP attivi</span><strong class="staff-top-count">{{ activeTopUsersCount }}</strong>
                  </button>
                  <button
                    type="button"
                    class="summary-pill summary-pill--clickable summary-pill--archive"
                    :class="{ 'summary-pill--active': topListView === 'history' }"
                    :aria-pressed="topListView === 'history'"
                    v-staff-top-tooltip="topControlHelp.history"
                    @click="setTopListView('history')"
                  >
                    <span>Storico TOP</span><strong class="staff-top-count">{{ topHistoryUsersCount }}</strong>
                  </button>
                </div>
              </div>

              <div class="filters-layout">
                <div class="filter-field filter-field--wide">
                  <label for="top-users-search">Ricerca rapida</label>
                  <input
                    id="top-users-search"
                    v-model.trim="searchQuery"
                    type="search"
                    class="search-bar"
                    placeholder="Email, nome, cognome o programma"
                    v-staff-top-tooltip="topControlHelp.search"
                  />
                </div>

                <div class="filter-field">
                  <label for="top-users-check-filter">Stato check</label>
                  <select
                    id="top-users-check-filter"
                    v-staff-top-tooltip="topControlHelp.check"
                    v-model="checkFilter"
                    class="search-bar"
                    @change="handleCheckFilterChange"
                  >
                    <option value="all">Tutti</option>
                    <option value="with_check">Con check</option>
                    <option value="without_check">Senza check</option>
                  </select>
                </div>
              </div>

              <div class="staff-top-quick-filters">
                <div class="staff-top-filter-section-heading">
                  <span id="staff-top-quick-label" class="staff-top-filter-label">Filtri rapidi</span>
                  <small id="staff-top-quick-help">Stato check e filtri rapidi si alternano.</small>
                </div>
                <div class="staff-top-quick-controls" role="group" aria-labelledby="staff-top-quick-label" aria-describedby="staff-top-quick-help">
                  <button
                    type="button"
                    class="summary-pill summary-pill--clickable summary-pill--danger"
                    :class="{ 'summary-pill--active': showRenewalOnly }"
                    :aria-pressed="showRenewalOnly"
                    v-staff-top-tooltip="showRenewalOnly ? 'Disattiva Da rinnovare. Mantiene ricerca e andamento.' : topControlHelp.renewal"
                    @click="toggleRenewalOnly"
                  >
                    <span>Da rinnovare</span><strong class="staff-top-count">{{ renewalUsersCount }}</strong>
                  </button>
                  <div class="staff-top-expiry-controls" :class="{ 'staff-top-expiry-controls--active': showExpiringOnly }" role="group" aria-label="In scadenza entro il periodo selezionato">
                    <button
                      type="button"
                      class="filter-action-button"
                      :class="{ 'filter-action-button--active': showExpiringOnly }"
                      :aria-pressed="showExpiringOnly"
                      v-staff-top-tooltip="showExpiringOnly ? 'Disattiva In scadenza. Mantiene ricerca e andamento.' : topControlHelp.expiring"
                      @click="toggleExpiringOnly"
                    >
                      <span class="material-icons" aria-hidden="true">event_busy</span>
                      <span>In scadenza</span>
                    </button>
                    <label for="expiring-window" class="staff-top-filter-sr-only">Periodo scadenze</label>
                    <select id="expiring-window" v-model.number="expiringWindowDays" class="search-bar" v-staff-top-tooltip="topControlHelp.period">
                      <option :value="7">7 giorni</option>
                      <option :value="15">15 giorni</option>
                      <option :value="30">30 giorni</option>
                      <option :value="60">60 giorni</option>
                      <option :value="90">90 giorni</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="staff-top-progress-filter">
                <div class="staff-top-progress-copy">
                  <span id="staff-top-progress-label">Andamento percorsi</span>
                  <small id="staff-top-progress-help">Si combina con gli altri filtri. Conta l’ultimo step attivo o completato.</small>
                </div>
                <div
                  class="staff-top-progress-toggle"
                  role="group"
                  aria-labelledby="staff-top-progress-label"
                  aria-describedby="staff-top-progress-help"
                >
                  <button
                    type="button"
                    class="staff-top-progress-option"
                    :aria-pressed="progressFilter === 'all'"
                    v-staff-top-tooltip="topControlHelp.allProgress"
                    @click="progressFilter = 'all'"
                  >Tutti</button>
                  <button
                    type="button"
                    class="staff-top-progress-option staff-top-progress-option--on-track"
                    :aria-pressed="progressFilter === 'on_track'"
                    v-staff-top-tooltip="topControlHelp.onTrack"
                    @click="progressFilter = 'on_track'"
                  >In linea</button>
                  <button
                    type="button"
                    class="staff-top-progress-option staff-top-progress-option--overdue"
                    :aria-pressed="progressFilter === 'overdue'"
                    v-staff-top-tooltip="topControlHelp.overdue"
                    @click="progressFilter = 'overdue'"
                  >In ritardo</button>
                </div>
              </div>

              <div class="filters-summary staff-top-filter-footer">
                <div class="filters-summary-stats">
                  <span>
                    Visualizzati
                    <strong>{{ filteredUsers.length }}/{{ currentTopViewUsers.length }}</strong>
                  </span>
                  <span>
                    Con check nella vista
                    <strong>{{ usersWithCheckCount }}</strong>
                  </span>
                </div>
                <div class="staff-top-filter-tools" role="group" aria-label="Strumenti e reset">
                  <button
                    type="button"
                    class="filter-action-button staff-top-control-filter"
                    :class="{ 'filter-action-button--active': showUnsavedOnly }"
                    :aria-pressed="showUnsavedOnly"
                    v-staff-top-tooltip="showUnsavedOnly ? 'Disattiva Non salvato. Mantiene ricerca e andamento.' : topControlHelp.unsaved"
                    @click="toggleUnsavedOnly"
                  >
                    <span class="material-icons" aria-hidden="true">flag</span>
                    <span>Non salvato</span>
                  </button>
                  <button
                    v-if="canAccessBackfill"
                    type="button"
                    class="filter-action-button filter-action-button--accent"
                    @click="goToBackfill"
                    v-staff-top-tooltip="topControlHelp.backfill"
                  >
                    <span class="material-icons" aria-hidden="true">build_circle</span>
                    <span>Backfill TOP</span>
                  </button>
                  <button
                    type="button"
                    class="filter-action-button filter-action-button--neutral"
                    :disabled="!hasActiveFilters"
                    @click="resetQuickFilters"
                    v-staff-top-tooltip="topControlHelp.reset"
                  >
                    <span class="material-icons" aria-hidden="true">restart_alt</span>
                    <span>Reset filtri</span>
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </section>

        <div v-if="isLoading || isTrackingLoading || loadError || trackingError" class="staff-top-load-status" :class="{ 'staff-top-load-status--error': loadError || trackingError }" role="status" aria-live="polite">
          <span v-if="isLoading || isTrackingLoading" class="tracking-loading-status__spinner" aria-hidden="true"></span>
          <div>
            <strong v-if="isLoading">{{ loadingMessage }}</strong>
            <strong v-else-if="loadError">{{ loadError }}</strong>
            <strong v-else-if="isTrackingLoading">Caricamento percorsi: {{ trackingLoadedUsers }}/{{ users.length }} utenti</strong>
            <strong v-else>{{ trackingError }}</strong>
            <p v-if="isTrackingLoading || trackingError">I conteggi e i filtri sui percorsi saranno completi al termine del caricamento.</p>
          </div>
          <button v-if="loadError && !isLoading" type="button" class="staff-button-neutral" @click="fetchTopUsers" v-staff-top-tooltip="'Riprova a caricare gli utenti TOP mantenendo i filtri.'">Riprova</button>
          <button v-else-if="trackingError && !isTrackingLoading" type="button" class="staff-button-neutral" @click="retryTopTracking" v-staff-top-tooltip="'Ricarica solo i percorsi non ancora ricevuti.'">Riprova percorsi</button>
        </div>

        <section class="top-monitor-shell card-surface">
          <nav
            v-if="!isLoading && filteredUsers.length"
            class="top-list-pagination"
            aria-label="Paginazione utenti TOP"
          >
            <span class="top-list-pagination__summary">
              Righe {{ paginationStart }}–{{ paginationEnd }} di {{ filteredUsers.length }}
            </span>
            <label class="top-list-pagination__size">
              <span>Per pagina</span>
              <select v-model.number="pageSize" v-staff-top-tooltip="topControlHelp.pageSize">
                <option
                  v-for="option in pageSizeOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </select>
            </label>
            <div class="top-list-pagination__buttons">
              <button
                type="button"
                :disabled="currentPage <= 1"
                aria-label="Prima pagina"
                v-staff-top-tooltip="'Torna alla prima pagina dei risultati filtrati.'"
                @click="goToPage(1)"
              >
                <span class="material-icons" aria-hidden="true">first_page</span>
              </button>
              <button
                type="button"
                :disabled="currentPage <= 1"
                aria-label="Pagina precedente"
                v-staff-top-tooltip="'Mostra la pagina precedente, mantenendo i filtri.'"
                @click="goToPage(currentPage - 1)"
              >
                <span class="material-icons" aria-hidden="true">chevron_left</span>
              </button>
              <span>Pagina {{ currentPage }} di {{ totalPages }}</span>
              <button
                type="button"
                :disabled="currentPage >= totalPages"
                aria-label="Pagina successiva"
                v-staff-top-tooltip="'Mostra la pagina successiva, mantenendo i filtri.'"
                @click="goToPage(currentPage + 1)"
              >
                <span class="material-icons" aria-hidden="true">chevron_right</span>
              </button>
              <button
                type="button"
                :disabled="currentPage >= totalPages"
                aria-label="Ultima pagina"
                v-staff-top-tooltip="'Vai all’ultima pagina dei risultati filtrati.'"
                @click="goToPage(totalPages)"
              >
                <span class="material-icons" aria-hidden="true">last_page</span>
              </button>
            </div>
          </nav>

          <p id="staff-top-scroll-help" class="staff-top-scroll-help">
            <span class="material-icons" aria-hidden="true">swap_horiz</span>
            <span>Scorri la tabella per vedere programmi, check, note e azioni.</span>
          </p>
          <div class="tickets top-monitor-scroll" tabindex="0" role="region" aria-label="Percorsi utenti TOP" aria-describedby="staff-top-scroll-help">
            <table class="users-table" :style="{ minWidth: `${topTableMinWidth}px` }">
            <thead>
              <tr>
                <th class="saved-column" rowspan="2">Salvato</th>
                <th class="user-column" rowspan="2">Utente</th>
                <th class="top-order-column" rowspan="2">Ordine TOP</th>
                <th
                  v-for="program in trackingPrograms"
                  :key="program.index"
                  :colspan="program.steps.length"
                  :class="[
                    'program-group-column',
                    `program-group-column--tone-${program.toneIndex}`,
                    { 'program-group-column--group-gap': program.index > 1 },
                  ]"
                >
                  <span class="staff-top-program-label">{{ program.label }}</span>
                </th>
                <th class="check-column" rowspan="2">Check fatto</th>
                <th class="note-column" rowspan="2">Note</th>
                <th class="actions-column" rowspan="2">Azioni</th>
              </tr>
              <tr>
                <th
                  v-for="column in trackingColumns"
                  :key="column.id"
                  :class="[
                    'step-status-column',
                    `step-status-column--tone-${column.toneIndex}`,
                    {
                      'step-status-column--group-start': column.isFirstInProgram,
                      'step-status-column--group-end': column.isLastInProgram,
                      'step-status-column--group-gap': column.hasGroupGap,
                    },
                  ]"
                >
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="user in paginatedUsers"
                :key="user.uid"
                :class="{
                  'users-row--top-renewal': needsTopRenewal(user),
                  'users-row--top-history': isTopHistoryUser(user),
                }"
              >
                <td class="saved-cell">
                  <label
                    class="saved-flag"
                    :class="{ 'saved-flag--saving': savingContactFlags[user.uid] }"
                  >
                    <input
                      type="checkbox"
                      aria-label="Contatto salvato sul telefono"
                      v-staff-top-tooltip="user.contactSaved ? 'Rimuove la spunta: il contatto risulterà Non salvato.' : topControlHelp.savedContact"
                      :checked="!!user.contactSaved"
                      :disabled="!!savingContactFlags[user.uid]"
                      @change="toggleContactSaved(user, $event.target.checked)"
                    />
                  </label>
                </td>
                <td class="user-cell">
                  <div class="user-card" :title="userIdentityTooltipLabel(user)">
                    <div class="user-card__name-row">
                      <span class="user-card__name">{{ formatUserFullName(user) }}</span>
                    </div>
                    <div class="user-card__email">{{ user.email || '—' }}</div>
                    <div
                      v-if="user._latestCheckProgramTitle"
                      class="user-card__program"
                    >
                      {{ user._latestCheckProgramTitle }}
                    </div>
                  </div>
                </td>
                <td class="top-order-cell">
                  <div
                    v-if="hasTopOrderDetails(user)"
                    class="top-order-card"
                    :title="topOrderTooltipLabel(user)"
                  >
                    <span class="top-order-chip">
                      <span class="material-icons" aria-hidden="true">info</span>
                      <span>TOP</span>
                    </span>
                    <div class="top-order-card__meta">
                      <span>{{ user._topOrderTime ? formatDate(user._topOrderTime) : '—' }}</span>
                      <span>{{ formatTopOrderProgramCount(user._topOrderProgramCount) }}</span>
                      <span v-if="user._topOrderExpiryMs">Scade {{ formatDate(user._topOrderExpiryMs) }}</span>
                    </div>
                    <div
                      v-if="hasTopCycleDetails(user) || topLifecycleStatusLabel(user)"
                      class="top-order-card__badges"
                    >
                      <span
                        v-if="topCycleLabel(user)"
                        class="top-order-mini-chip"
                      >
                        {{ topCycleLabel(user) }}
                      </span>
                      <span
                        v-if="topCompletedCycleLabel(user)"
                        class="top-order-mini-chip top-order-mini-chip--done"
                      >
                        {{ topCompletedCycleLabel(user) }}
                      </span>
                      <span
                        v-if="hasTopRenewed(user)"
                        class="top-order-mini-chip top-order-mini-chip--renewed"
                      >
                        Rinnovato
                      </span>
                      <span
                        v-if="topLifecycleStatusLabel(user)"
                        class="top-order-mini-chip"
                        :class="topLifecycleStatusClass(user)"
                        :title="topLifecycleStatusTitle(user)"
                      >
                        {{ topLifecycleStatusLabel(user) }}
                      </span>
                    </div>
                  </div>
                  <div v-else class="top-order-card top-order-card--empty">
                    <span>—</span>
                  </div>
                </td>
                <td
                  v-for="column in trackingColumns"
                  :key="column.id"
                  :class="[
                    'step-status-cell',
                    `step-status-cell--tone-${column.toneIndex}`,
                    {
                      'step-status-cell--group-start': column.isFirstInProgram,
                      'step-status-cell--group-end': column.isLastInProgram,
                      'step-status-cell--group-gap': column.hasGroupGap,
                    },
                  ]"
                >
                  <div
                    v-if="hasVisibleTrackingState(user, column)"
                    class="step-status-stack"
                    :title="stepTrackingTitle(user, column)"
                  >
                    <span class="step-status-pill" :class="stepTrackingClass(user, column)">
                      <span>{{ stepTrackingLabel(user, column) }}</span>
                      <span
                        v-if="stepTrackingShowsApprovedIcon(user, column)"
                        class="step-status-icon material-icons"
                        title="Questionario approvato e inviato"
                        aria-label="Questionario approvato e inviato"
                      >
                        mark_email_read
                      </span>
                    </span>
                    <small
                      class="step-status-meta"
                      :class="{ 'step-status-meta--hidden': !stepTrackingMeta(user, column) }"
                    >
                      {{ stepTrackingMeta(user, column) || ' ' }}
                    </small>
                  </div>
                  <div v-else class="step-status-empty"></div>
                </td>
                <td class="check-cell">
                  <div
                    v-if="user._topTrackingLoading"
                    class="tracking-cell-loading"
                    aria-label="Caricamento percorso"
                  >
                    <span class="tracking-loading-status__spinner" aria-hidden="true"></span>
                  </div>
                  <span v-else-if="user._topTrackingError" class="staff-top-load-unavailable">Non caricato</span>
                  <div v-else-if="user._latestCheckDoneAt" class="check-date">
                    <span class="check-date__value" :title="checkDateTitle(user)">
                      {{ formatDate(user._latestCheckDoneAt) }}
                    </span>
                    <small v-if="user._latestCheckDoneAt" class="check-date__meta">
                      {{ relativeCheckLabel(user) }}
                    </small>
                  </div>
                  <div v-else class="check-diagnostic-wrap">
                    <span class="check-diagnostic-empty">—</span>
                    <span
                      class="check-diagnostic-trigger"
                      tabindex="0"
                      :aria-label="checkDiagnosticAriaLabel(user)"
                    >
                      <span class="material-icons" aria-hidden="true">info</span>
                    </span>
                    <div class="check-diagnostic-tooltip" role="tooltip">
                      <div class="check-diagnostic-tooltip__title">
                        {{ checkDiagnosticTitle(user) }}
                      </div>
                      <div
                        v-for="(line, index) in checkDiagnosticLines(user)"
                        :key="`${user.uid}-check-diagnostic-${index}`"
                        class="check-diagnostic-tooltip__line"
                      >
                        {{ line }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="note-cell">
                  <div class="note-field">
                    <input
                      v-model="user[TOP_LIST_NOTE_FIELD]"
                      type="text"
                      class="note-input"
                      placeholder="Aggiungi nota"
                      aria-label="Note utente TOP"
                      v-staff-top-tooltip="topControlHelp.note"
                      @input="queueTopListNoteSave(user)"
                      @blur="queueTopListNoteSave(user, true)"
                    />
                    <small
                      v-if="savingNoteFlags[user.uid]"
                      class="note-save-status"
                    >
                      Salvo...
                    </small>
                  </div>
                </td>
                <td class="actions-cell">
                  <div class="buttons-container">
                    <button
                      type="button"
                      v-staff-top-tooltip="topControlHelp.userDetails"
                      aria-label="Apri dettaglio utente"
                      class="staff-top-icon-button staff-button-neutral"
                      @click="viewUserDetails(user.uid)"
                    >
                      <span class="material-icons" aria-hidden="true">visibility</span>
                    </button>
                    <button
                      type="button"
                      :disabled="!!savingVisibilityFlags[user.uid]"
                      v-staff-top-tooltip="isTopHistoryUser(user) ? topControlHelp.restore : topControlHelp.archive"
                      :aria-label="isTopHistoryUser(user) ? 'Forza tra i TOP attivi' : 'Sposta nello Storico TOP'"
                      class="staff-top-icon-button"
                      :class="isTopHistoryUser(user) ? 'staff-button-positive' : 'staff-button-warning'"
                      @click="isTopHistoryUser(user) ? restoreUserToActiveTop(user) : moveUserToTopHistory(user)"
                    >
                      <span class="material-icons" aria-hidden="true">
                        {{ savingVisibilityFlags[user.uid]
                          ? 'hourglass_top'
                          : isTopHistoryUser(user)
                            ? 'unarchive'
                            : 'archive' }}
                      </span>
                    </button>
                    <button
                      v-if="hasTopVisibilityOverride(user)"
                      type="button"
                      :disabled="!!savingVisibilityFlags[user.uid]"
                      v-staff-top-tooltip="topControlHelp.automatic"
                      aria-label="Torna alla gestione automatica"
                      class="staff-top-icon-button staff-button-neutral"
                      @click="resetTopVisibilityOverride(user)"
                    >
                      <span class="material-icons" aria-hidden="true">sync</span>
                    </button>
                    <span
                      v-if="user.ticketStatus"
                      :class="{
                        orange: user.ticketStatus === 'Aperto',
                        green: user.ticketStatus === 'Risposto',
                        yellow: user.ticketStatus === 'Non Risposto'
                      }"
                      class="status-dot">
                    </span>
                  </div>
                </td>
              </tr>
              <tr v-if="!isLoading && filteredUsers.length === 0">
                <td :colspan="emptyStateColspan" class="empty-state">
                  {{
                    loadError ? 'La lista non è stata caricata. Premi Riprova.'
                      : isTrackingLoading ? 'Attendo i percorsi per aggiornare i risultati…'
                        : trackingError ? 'Alcuni percorsi non sono disponibili. Riprova il caricamento.'
                          : hasActiveFilters ? 'Nessun utente corrisponde ai filtri selezionati.'
                            : topListView === 'history' ? 'Nessuna cliente nello Storico TOP.'
                              : 'Nessun utente TOP attivo trovato.'
                  }}
                </td>
              </tr>
            </tbody>
            </table>
          </div>

          <nav
            v-if="!isLoading && totalPages > 1"
            class="top-list-pagination top-list-pagination--bottom"
            aria-label="Paginazione utenti TOP in fondo alla tabella"
          >
            <span class="top-list-pagination__summary">
              Righe {{ paginationStart }}–{{ paginationEnd }} di {{ filteredUsers.length }}
            </span>
            <div class="top-list-pagination__buttons">
              <button
                type="button"
                :disabled="currentPage <= 1"
                aria-label="Pagina precedente"
                v-staff-top-tooltip="'Mostra la pagina precedente, mantenendo i filtri.'"
                @click="goToPage(currentPage - 1)"
              >
                <span class="material-icons" aria-hidden="true">chevron_left</span>
              </button>
              <span>Pagina {{ currentPage }} di {{ totalPages }}</span>
              <button
                type="button"
                :disabled="currentPage >= totalPages"
                aria-label="Pagina successiva"
                v-staff-top-tooltip="'Mostra la pagina successiva, mantenendo i filtri.'"
                @click="goToPage(currentPage + 1)"
              >
                <span class="material-icons" aria-hidden="true">chevron_right</span>
              </button>
            </div>
          </nav>
        </section>
      </div>
    </div>
  </div>

  <div v-if="showCreateConversationModal" class="modal staff-top-modal">
    <div class="modal-content">
      <button type="button" class="close staff-top-icon-button staff-button-cancel" aria-label="Chiudi nuova conversazione" v-staff-top-tooltip="'Chiude e scarta il messaggio non ancora creato.'" @click="closeCreateConversationModal"><span class="material-icons" aria-hidden="true">close</span></button>
      <h2>Apri una nuova conversazione tecnica</h2>

      <form @submit.prevent="createConversation">
        <div>
          <label for="title">Titolo del messaggio:</label>
          <input type="text" v-model="newConversation.title" placeholder="Inserisci il titolo..." v-staff-top-tooltip="'Scrivi un titolo breve per riconoscere la conversazione.'" />
        </div>

        <div>
          <label for="message">Messaggio:</label>
          <textarea v-model="newConversation.message" placeholder="Scrivi il tuo messaggio..." v-staff-top-tooltip="'Scrivi il messaggio da inviare quando crei la conversazione.'"></textarea>
        </div>

        <button type="button" class="staff-button-neutral" v-staff-top-tooltip="'Scegli un testo predefinito da aggiungere al messaggio.'" @click="openDeliveryMessagesModal">Messaggi di consegna</button>

        <button class="staff-button-positive" type="submit" :disabled="isCreatingConversation" v-staff-top-tooltip="'Crea la conversazione tecnica con il messaggio inserito.'">{{ isCreatingConversation ? 'Invio…' : 'Crea Conversazione' }}</button>
      </form>
    </div>
  </div>

  <div class="modal staff-top-modal" v-if="showDeliveryMessagesModal">
    <div class="modal-content">
      <button type="button" class="close staff-top-icon-button staff-button-cancel" aria-label="Chiudi messaggi di consegna" v-staff-top-tooltip="'Torna alla composizione della conversazione.'" @click="closeDeliveryMessagesModal"><span class="material-icons" aria-hidden="true">close</span></button>
      <h2>Messaggi di Consegna</h2>
      <div class="message-section" v-for="(message, index) in deliveryMessages" :key="index">
        <h3>{{ message.title }}</h3>
        <pre v-html="truncateMessage(message.content, index)"></pre>
        <div class="message-actions">
          <button class="staff-button-neutral" v-if="!showFullMessage[index]" v-staff-top-tooltip="'Espande l’anteprima per leggere tutto il testo.'" @click="toggleFullMessage(index)">Mostra tutto</button>
          <button class="staff-button-neutral" v-else v-staff-top-tooltip="'Riduce l’anteprima del testo.'" @click="toggleFullMessage(index)">Mostra meno</button>
          <button class="copy-button staff-button-positive" v-staff-top-tooltip="'Aggiunge questo testo al messaggio, senza inviarlo.'" @click="copyMessageToConversation(message.content)">Copia nel messaggio</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed, nextTick, onUnmounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getFirestore, collection, getDocs, query, where, orderBy, limit, startAfter, documentId, doc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import SidebarComponent from '../SidebarComponent.vue';
import staffTopTooltip from '@/lib/staffTopTooltip';
import { readTopSnapshot } from '@/lib/topListQuery';
import { resolveOrderTimeMs, hasTopSkuMatch, isPaidOrder } from '@/lib/topSku';
import { createTechnicalTicket, createTechnicalMessageId } from '@/lib/technicalTicketMessages';

const TOP_CHUNK_SIZE = 30;
const TOP_ORDER_PAGE_SIZE = 400;
const TOP_UID_BATCH_SIZE = 30;
const TOP_LIST_DEFAULT_PAGE_SIZE = 50;
const TOP_LIST_PAGE_SIZE_OPTIONS = Object.freeze([25, 50, 100]);
const CONTACT_SAVED_FIELD = 'contactSaved';
const TOP_LIST_NOTE_FIELD = 'topListNote';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
const TOP_LIST_VISIBILITY_OVERRIDE_FIELD = 'topListVisibilityOverride';
const TOP_LIST_VISIBILITY_OVERRIDE_AT_FIELD = 'topListVisibilityOverrideAt';
const TOP_LIST_VISIBILITY_OVERRIDE_BY_FIELD = 'topListVisibilityOverrideBy';
const TOP_LIST_VISIBILITY_OVERRIDE_REASON_FIELD = 'topListVisibilityOverrideReason';
const TOP_LIST_VISIBILITY_AUTO = 'auto';
const TOP_LIST_VISIBILITY_ACTIVE = 'active';
const TOP_LIST_VISIBILITY_ARCHIVE = 'archive';
const TOP_LIST_QUERY_CONCURRENCY = 6;
const TOP_BACKFILL_PRIV_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const TOP_BACKFILL_PRIV_EMAIL = 'valeriobianconi@gmail.com';
const TOP_CONTROL_HELP = Object.freeze({
  search: 'Cerca per email, nome, cognome o programma. Si combina con i filtri selezionati.',
  check: 'Con o senza un check finale completato con data. Con check e Senza check sostituiscono gli altri filtri rapidi.',
  period: 'Scegli quanti giorni considerare quando attivi Scadenze.',
  expiring: 'Ordini TOP in scadenza da oggi entro il periodo scelto. Sostituisce gli altri filtri rapidi; mantiene ricerca e andamento.',
  unsaved: 'Contatti non segnati come salvati sul telefono. Sostituisce gli altri filtri rapidi; mantiene ricerca e andamento.',
  backfill: 'Apre lo strumento per aggiornare il riconoscimento degli ordini TOP. Non avvia subito l’aggiornamento.',
  reset: 'Azzera ricerca e filtri, riporta il periodo a 30 giorni e mantiene la vista attuale.',
  allProgress: 'Mostra tutti gli andamenti, anche quelli senza dati valutabili. Gli altri filtri restano attivi.',
  onTrack: 'L’ultimo step è fatto, previsto oggi o in linea. I ritardi precedenti non contano. Si combina con gli altri filtri.',
  overdue: 'L’ultimo step attivo è in ritardo. Un ritardo seguito da uno step fatto non conta. Si combina con gli altri filtri.',
  active: 'TOP non archiviati, anche con pacchetto scaduto. Cambiando vista azzera i filtri rapidi; mantiene ricerca e andamento.',
  history: 'TOP archiviati manualmente o passati a Plus/Basic. Cambiando vista azzera i filtri rapidi; mantiene ricerca e andamento.',
  renewal: 'TOP attivi con consegna dell’ultimo programma fatta, senza rinnovi o passaggi già previsti. Sostituisce gli altri filtri rapidi; mantiene ricerca e andamento.',
  pageSize: 'Scegli quanti utenti mostrare in ogni pagina. Riparte dalla prima pagina e mantiene i filtri.',
  savedContact: 'Segna che hai già salvato il contatto sul telefono. La spunta non aggiunge il numero alla rubrica.',
  note: 'La nota viene salvata automaticamente mentre scrivi.',
  userDetails: 'Apre il profilo utente in una nuova scheda.',
  archive: 'Sposta manualmente l’utente nello Storico TOP. Puoi indicare un motivo.',
  restore: 'Riporta l’utente tra i TOP attivi e sospende la gestione automatica, fino al suo ripristino.',
  automatic: 'Rimuove la scelta manuale e riapplica le regole automatiche per TOP attivi e Storico.',
});
const FIRST_TRACKING_PROGRAM_STEPS = [
  { slot: 'questionario', label: 'Questionario' },
  { slot: 'consulenza_nutrizionale', label: 'Cons. nutriz.' },
  { slot: 'consegna', label: 'Consegna' },
  { slot: 'consulenza_tecnica', label: 'Cons. tecnica' },
  { slot: 'check_finale', label: 'Check finale' },
];
const FOLLOWUP_TRACKING_PROGRAM_STEPS = [
  { slot: 'consegna', label: 'Consegna' },
  { slot: 'consulenza_tecnica', label: 'Cons. tecnica' },
  { slot: 'check_finale', label: 'Check finale' },
];
const FIXED_TABLE_COLUMNS = 6;
const TRACKING_STEP_COLUMN_WIDTH = 132;
const TRACKING_GROUP_GAP = 18;

const resolveTrackingToneIndex = (programIndex) => {
  const normalized = Number(programIndex);
  if (!Number.isFinite(normalized) || normalized <= 0) return 1;
  return ((normalized - 1) % 4) + 1;
};

const buildTrackingPrograms = (totalPrograms = 0) => {
  const total = Number(totalPrograms);
  if (!Number.isFinite(total) || total <= 0) return [];

  return Array.from({ length: total }, (_, idx) => {
    const index = idx + 1;
    const steps = index === 1 ? FIRST_TRACKING_PROGRAM_STEPS : FOLLOWUP_TRACKING_PROGRAM_STEPS;
    return {
      index,
      label: `Programma ${index}`,
      steps,
      toneIndex: resolveTrackingToneIndex(index),
    };
  });
};

const buildTrackingColumns = (programs = []) =>
  programs.flatMap((program) =>
    program.steps.map((step, stepIndex) => ({
      id: `p${program.index}_${step.slot}`,
      programIndex: program.index,
      programLabel: program.label,
      stepSlot: step.slot,
      label: step.label,
      toneIndex: program.toneIndex,
      isFirstInProgram: stepIndex === 0,
      isLastInProgram: stepIndex === program.steps.length - 1,
      hasGroupGap: stepIndex === 0 && program.index > 1,
    }))
  );

const buildEmptyStateColspan = (columns = []) => FIXED_TABLE_COLUMNS + columns.length;

const normalizeEmail = (value) => String(value || '').trim().toLowerCase();
const normalizeSkuKey = (value) => String(value || '').toLowerCase().trim().replace(/[^a-z0-9]/g, '');

const chunkList = (items, size) => {
  const out = [];
  for (let i = 0; i < items.length; i += size) {
    out.push(items.slice(i, i + size));
  }
  return out;
};

const mapWithConcurrency = async (items = [], concurrency = TOP_LIST_QUERY_CONCURRENCY, worker) => {
  const source = Array.isArray(items) ? items : [];
  if (!source.length) return [];

  const results = new Array(source.length);
  const workerCount = Math.max(1, Math.min(Number(concurrency) || 1, source.length));
  let nextIndex = 0;

  const runners = Array.from({ length: workerCount }, async () => {
    while (nextIndex < source.length) {
      const currentIndex = nextIndex;
      nextIndex += 1;
      results[currentIndex] = await worker(source[currentIndex], currentIndex);
    }
  });

  await Promise.all(runners);
  return results;
};

const normalizeTopListVisibilityOverride = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  if (normalized === TOP_LIST_VISIBILITY_ACTIVE) return TOP_LIST_VISIBILITY_ACTIVE;
  if (normalized === TOP_LIST_VISIBILITY_ARCHIVE) return TOP_LIST_VISIBILITY_ARCHIVE;
  return TOP_LIST_VISIBILITY_AUTO;
};

const toDateSafe = (value) => {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value?.toDate === 'function') {
    const date = value.toDate();
    return date instanceof Date && !Number.isNaN(date.getTime()) ? date : null;
  }
  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const str = String(value).trim();
  if (!str) return null;
  const normalized = str.includes('T') ? str : str.replace(' ', 'T');
  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const addMonths = (date, months) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const amount = Number(months);
  if (!Number.isFinite(amount) || amount === 0) return new Date(date.getTime());
  const result = new Date(date.getTime());
  result.setMonth(result.getMonth() + amount);
  return result;
};

const stepKeyFromName = (name = '') => {
  const normalized = String(name || '').toLowerCase();
  if (normalized.includes('check') || normalized.includes('scadenza')) return 'check_finale';
  if (normalized.includes('questionario')) return 'questionario';
  if (normalized.includes('consegna')) return 'consegna';
  if (normalized.includes('consulenza')) return 'consulenza';
  return '';
};

const buildLatestCheckKey = (percorsoId, stepIndex, doneAtIso) =>
  [String(percorsoId || '').trim(), Number(stepIndex), String(doneAtIso || '').trim()].join('__');

const createEmptyCheckDiagnostic = () => ({
  percorsiCount: 0,
  percorsiWithoutSteps: 0,
  checkStepsFound: 0,
  convertedCheckSteps: 0,
  incompleteCheckSteps: 0,
  invalidDoneAtCheckSteps: 0,
});

const resolveUserCreatedTime = (user = {}) => {
  const candidates = [user.created_time, user.createdAt, user.created_at];
  for (const candidate of candidates) {
    const parsed = toDateSafe(candidate);
    if (parsed) return parsed.getTime();
  }
  return 0;
};

const buildProductsIndex = async (db, readDocs) => {
  const byId = new Map();
  const bySku = new Map();
  const snap = await readDocs(collection(db, 'products'));
  snap.forEach((docSnap) => {
    const data = docSnap.data() || {};
    const idKey = String(docSnap.id || '').trim();
    if (idKey) byId.set(idKey, data);
    const skuCandidate = data.sku || data.productSku || data.product_id || data.productId;
    const skuKey = normalizeSkuKey(skuCandidate);
    if (skuKey) bySku.set(skuKey, data);
  });
  return { byId, bySku };
};

const resolveCatalogProduct = (line = {}, productIndex) => {
  if (!productIndex) return null;
  const { byId, bySku } = productIndex;
  const idCandidates = [
    line.id,
    line.productId,
    line.product_id,
    line.catalogId,
    line.itemId,
  ];
  for (const candidate of idCandidates) {
    const key = String(candidate || '').trim();
    if (key && byId.has(key)) return byId.get(key);
  }
  const skuCandidates = [line.sku, line.SKU, line.productSku, line.product_sku];
  for (const candidate of skuCandidates) {
    const key = normalizeSkuKey(candidate);
    if (key && bySku.has(key)) return bySku.get(key);
  }
  return null;
};

const TOP_PROGRAM_DURATION_MONTHS = Object.freeze({
  1: 1,
  4: 5,
  6: 8,
  10: 12,
});

const firstPositiveNumber = (values = []) => {
  for (const value of values) {
    const number = Number(value);
    if (Number.isFinite(number) && number > 0) return number;
  }
  return 0;
};

const resolveLineTopProgramCount = (line = {}) => {
  const candidates = [
    line?.sku,
    line?.SKU,
    line?.productSku,
    line?.product_sku,
    line?.productId,
    line?.product_id,
    line?.name,
    line?.title,
    line?.productName,
  ];

  for (const value of candidates) {
    const text = String(value || '').trim();
    if (!text) continue;
    const normalized = normalizeSkuKey(text);
    if (normalized.includes('10topsoloallenamento')) return 10;

    const fcTopMatch = text.match(/\bfc\s*(\d+)\s*top\b/i) || normalized.match(/^fc(\d+)top$/i);
    if (fcTopMatch) {
      const count = Number(fcTopMatch[1]);
      if (Number.isFinite(count) && count > 0) return count;
    }

    const leadingTopMatch = text.match(/\b(\d+)\s*top\b/i);
    if (leadingTopMatch) {
      const count = Number(leadingTopMatch[1]);
      if (Number.isFinite(count) && count > 0) return count;
    }

    const programsMatch = text.match(/\b(\d+)\s*programmi\b/i);
    if (programsMatch) {
      const count = Number(programsMatch[1]);
      if (Number.isFinite(count) && count > 0) return count;
    }
  }

  return 0;
};

const resolveLineDurationMonths = (line = {}, productIndex) => {
  const product = resolveCatalogProduct(line, productIndex);
  const inferredProgramCount = resolveLineTopProgramCount(line);
  return firstPositiveNumber([
    product?.duration_months,
    product?.durationMonths,
    line?.duration_months,
    line?.durationMonths,
    line?.duration,
    TOP_PROGRAM_DURATION_MONTHS[inferredProgramCount],
  ]);
};

const resolveLineProgramCount = (line = {}, productIndex) => {
  const product = resolveCatalogProduct(line, productIndex);
  const inferredProgramCount = resolveLineTopProgramCount(line);
  return firstPositiveNumber([
    product?.program_count,
    product?.programCount,
    product?.programsCount,
    product?.coaching_quantity,
    product?.coachingQty,
    line?.program_count,
    line?.programCount,
    line?.programsCount,
    line?.coaching_quantity,
    line?.coachingQty,
    inferredProgramCount,
    resolveLineDurationMonths(line, productIndex),
  ]);
};

const lineMatchesTopSku = (line = {}) => {
  const candidates = [
    line?.sku,
    line?.SKU,
    line?.productSku,
    line?.product_sku,
    line?.name,
    line?.title,
    line?.productName,
  ];
  return candidates.some(hasTopSkuMatch);
};

const normalizeStepsArray = (steps) => {
  if (Array.isArray(steps)) {
    return steps.map((step) => (step && typeof step === 'object' ? { ...step } : step));
  }

  if (steps && typeof steps === 'object') {
    return Object.keys(steps)
      .sort((a, b) => Number(a) - Number(b))
      .map((key) => {
        const step = steps[key];
        return step && typeof step === 'object' ? { ...step } : step;
      });
  }

  return [];
};

const normalizePercorsoRecord = (percorso = {}) => ({
  ...percorso,
  steps: normalizeStepsArray(percorso?.steps),
});

const toComparableString = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (value instanceof Date) return value.toISOString();
  if (typeof value?.toDate === 'function') {
    try {
      return value.toDate().toISOString();
    } catch {
      return '';
    }
  }
  return String(value);
};

const parseSequenceIndex = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === 'string') {
    const match = value.match(/\d+/);
    return match ? Number(match[0]) : null;
  }
  return null;
};

const normalizeConsulenzaStatus = (status) => String(status || '').trim().toLowerCase();

const isConsulenzaStatusDone = (status) => {
  const normalized = normalizeConsulenzaStatus(status);
  return normalized === 'fatta' || normalized === 'rifiutata' || normalized === 'scalata';
};

const normalizeConsulenzaType = (raw) => {
  const value = String(raw || '').toLowerCase();
  if (value.includes('nutriz')) return 'nutrizionale';
  if (value.includes('tecnic')) return 'tecnica';
  return '';
};

const isBlockingStepForSequence = (step) => {
  const name = String(step?.name || '').toLowerCase();
  if (!name) return true;
  if (name.includes('feedback')) return false;
  return true;
};

const isStepEffectivelyDone = (step) => {
  if (!step) return false;
  const name = String(step?.name || '').toLowerCase();
  if (name.includes('consulenza') && isConsulenzaStatusDone(step?.consulenzaStatus)) {
    return true;
  }
  return !!step?.done;
};

const isRealCheckFinaleStep = (step = {}) => {
  const name = String(step?.name || '').toLowerCase();
  const isCheck = name.includes('check') || name.includes('scadenza');
  if (!isCheck) return false;
  return !step?.convertedFromQuestionario;
};

const blockingStepsOnly = (steps = []) =>
  (Array.isArray(steps) ? steps : []).filter(isBlockingStepForSequence);

const hasCheckFinaleDone = (steps = []) =>
  (Array.isArray(steps) ? steps : []).some(
    (step) => isRealCheckFinaleStep(step) && isStepEffectivelyDone(step)
  );

const hasConsegnaDone = (steps = []) =>
  (Array.isArray(steps) ? steps : []).some(
    (step) => stepKeyFromName(step?.name) === 'consegna' && isStepEffectivelyDone(step)
  );

const isPercorsoFullyCompleted = (percorso) => {
  const steps = Array.isArray(percorso?.steps) ? percorso.steps : [];
  if (!steps.length) return false;
  if (hasCheckFinaleDone(steps)) return true;
  const blockingSteps = blockingStepsOnly(steps);
  if (!blockingSteps.length) return true;
  return blockingSteps.every(isStepEffectivelyDone);
};

const isPercorsoHistoryLocked = (percorso) => !!percorso?.historyLocked;
const hasSequenceUnlockOverride = (percorso) => percorso?.sequenceUnlockOverride === true;
const hasCompletedUnlockOverride = (percorso) => percorso?.completedUnlockOverride === true;
const isPercorsoCompleteForLocking = (percorso) =>
  isPercorsoFullyCompleted(percorso) || isPercorsoHistoryLocked(percorso);

const sortPercorsiBySequence = (a, b) => {
  const ix = Number(a?.sequenceIndex) || 0;
  const iy = Number(b?.sequenceIndex) || 0;
  if (ix !== iy) return ix - iy;
  const ax = toComparableString(a?.plannedStartAt || a?.createdAt);
  const ay = toComparableString(b?.plannedStartAt || b?.createdAt);
  return ax.localeCompare(ay);
};

const buildOrderedPercorsoGroups = (rows = []) => {
  const normalizedRows = rows
    .map((row) => normalizePercorsoRecord(row))
    .filter((row) => !row?.consulenzeOnly);

  const groups = new Map();
  const groupMeta = new Map();

  for (const percorso of normalizedRows) {
    const groupId = percorso.sequenceGroupId || percorso.id;
    const groupRows = groups.get(groupId) || [];
    groupRows.push(percorso);
    groups.set(groupId, groupRows);

    const anchorThis = toComparableString(percorso.plannedStartAt || percorso.createdAt);
    const meta = groupMeta.get(groupId) || { anchor: anchorThis || '' };
    if (!meta.anchor || (anchorThis && anchorThis < meta.anchor)) {
      meta.anchor = anchorThis;
    }
    groupMeta.set(groupId, meta);
  }

  const groupOrder = Array.from(groups.keys()).sort((a, b) => {
    const aa = toComparableString(groupMeta.get(a)?.anchor);
    const bb = toComparableString(groupMeta.get(b)?.anchor);
    return bb.localeCompare(aa);
  });

  return groupOrder.map((groupId) => ({
    id: groupId,
    anchor: groupMeta.get(groupId)?.anchor || '',
    percorsi: [...(groups.get(groupId) || [])].sort(sortPercorsiBySequence),
  }));
};

const buildSequentialLocks = (groups = []) => {
  const locks = {};

  for (const group of groups) {
    const sorted = [...(group?.percorsi || [])].sort(sortPercorsiBySequence);
    if (!sorted.length) continue;

    const gatingActive = sorted.length > 1 || Number(sorted[0]?.sequenceTotal) > 1;
    let blockNext = false;

    sorted.forEach((percorso) => {
      if (!gatingActive) {
        locks[percorso.id] = false;
        return;
      }

      const override = hasSequenceUnlockOverride(percorso);
      locks[percorso.id] = blockNext && !override;
      const isComplete = isPercorsoCompleteForLocking(percorso);
      blockNext = !isComplete;
    });
  }

  return locks;
};

const buildPreviousGroupLocks = (groups = []) => {
  const locks = {};
  let blockFollowing = false;
  const orderedGroups = [...groups].sort((a, b) =>
    String(a?.anchor || '').localeCompare(String(b?.anchor || ''))
  );

  for (const group of orderedGroups) {
    const list = group?.percorsi || [];
    const groupCompleted = list.every(
      (percorso) => hasSequenceUnlockOverride(percorso) || isPercorsoCompleteForLocking(percorso)
    );

    list.forEach((percorso) => {
      locks[percorso.id] = blockFollowing && !hasSequenceUnlockOverride(percorso);
    });

    if (!groupCompleted) {
      blockFollowing = true;
    }
  }

  return locks;
};

const getPercorsoLockReason = (percorso, sequentialLocks = {}, previousGroupLocks = {}) => {
  if (isPercorsoHistoryLocked(percorso)) return 'history';
  if (isPercorsoFullyCompleted(percorso) && !hasCompletedUnlockOverride(percorso)) return 'completed';
  if (previousGroupLocks[percorso?.id]) return 'previous_group';
  if (sequentialLocks[percorso?.id]) return 'sequence';
  return null;
};

const isFirstProgramInSequence = (percorso) => {
  const idx = parseSequenceIndex(percorso?.sequenceIndex);
  const total = Number(percorso?.sequenceTotal);
  if (idx === 1) return true;
  if (idx == null && (!Number.isFinite(total) || total <= 1)) return true;
  return false;
};

const STEP_ORDER = {
  questionario: 3,
  consegna: 6,
  consulenza: 10,
  check_finale: 12,
};

const stepOrderForPercorso = (percorso, key, consulenzaType, step) => {
  const normalizedType = normalizeConsulenzaType(consulenzaType);
  if (isFirstProgramInSequence(percorso)) {
    if (key === 'questionario') return 1;
    if (key === 'check_finale' && step?.convertedFromQuestionario) return 1;
    if (key === 'consulenza' && normalizedType === 'nutrizionale') return 2;
    if (key === 'consegna') return 3;
    if (key === 'consulenza' && normalizedType === 'tecnica') return 4;
    if (key === 'check_finale') return 5;
  }
  let order = STEP_ORDER[key] ?? 99;
  if (key === 'consulenza' && normalizedType === 'nutrizionale') {
    order = 2;
  }
  return order;
};

const buildStepRowsForPercorso = (percorso) => {
  const all = Array.isArray(percorso?.steps) ? percorso.steps : [];
  if (!all.length) return [];

  const rows = all
    .map((step, idx) => {
      const key = stepKeyFromName(step?.name);
      if (!key) return null;
      return {
        key,
        realIndex: idx,
        step,
        isDone: isStepEffectivelyDone(step),
        order: stepOrderForPercorso(percorso, key, step?.consulenzaType, step),
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      if (a.order !== b.order) return a.order - b.order;
      return a.realIndex - b.realIndex;
    });

  const consegnaRow = rows.find((row) => row.key === 'consegna');
  const consegnaDone = consegnaRow ? consegnaRow.isDone : true;

  rows.forEach((row) => {
    if (row.key !== 'check_finale') return;
    const checkAlreadyDone = row.isDone;
    const hasOverride = !!row.step?.allowCheckOverride;
    const converted = !!row.step?.convertedFromQuestionario;
    row.isLockedByConsegna = !converted && !checkAlreadyDone && !consegnaDone && !hasOverride;
  });

  return rows;
};

const matchesTopPercorso = (percorso = {}) => {
  const candidates = [percorso?.title, percorso?.productName];
  return candidates.some((candidate) => hasTopSkuMatch(candidate));
};

const normalizeAdminDailyState = (rawState, sentFlag = false) => {
  const state = String(rawState || '').trim().toLowerCase();
  if (state === 'inviato' || state === 'nascosto') return state;
  return sentFlag ? 'inviato' : '';
};

const resolveStepAdminDailyState = (step) =>
  normalizeAdminDailyState(step?.adminDailyState, step?.adminDailySent);

const formatStepDateLabel = (value) => {
  const date = toDateSafe(value);
  return date ? date.toLocaleDateString('it-IT') : '';
};

const dayStartMs = (value) => {
  const date = toDateSafe(value);
  if (!date) return null;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
};

const getDayDiffFromToday = (value) => {
  const target = dayStartMs(value);
  const today = dayStartMs(new Date());
  if (target == null || today == null) return null;
  return Math.round((target - today) / DAY_IN_MS);
};

const formatDayDiffLabel = (diff) => {
  if (diff == null) return '';
  if (diff === 0) return 'oggi';
  if (diff < 0) {
    const abs = Math.abs(diff);
    return abs === 1 ? 'ritardo 1 gg' : `ritardo ${abs} gg`;
  }
  return diff === 1 ? 'tra 1 gg' : `tra ${diff} gg`;
};

const formatCompactDayDiffLabel = (diff) => {
  if (diff == null) return '';
  if (diff === 0) return 'oggi';
  if (diff < 0) return `-${Math.abs(diff)}g`;
  return `+${diff}g`;
};

const resolveTrackingRowForSlot = (rows = [], slot = '') => {
  if (slot === 'questionario') {
    return (
      rows.find((row) => row.key === 'questionario') ||
      rows.find((row) => row.key === 'check_finale' && row.step?.convertedFromQuestionario) ||
      null
    );
  }
  if (slot === 'consulenza_nutrizionale') {
    return (
      rows.find(
        (row) => row.key === 'consulenza' && normalizeConsulenzaType(row.step?.consulenzaType) === 'nutrizionale'
      ) || null
    );
  }
  if (slot === 'consulenza_tecnica') {
    return (
      rows.find(
        (row) => row.key === 'consulenza' && normalizeConsulenzaType(row.step?.consulenzaType) === 'tecnica'
      ) || null
    );
  }
  if (slot === 'check_finale') {
    return rows.find((row) => row.key === 'check_finale' && !row.step?.convertedFromQuestionario) || null;
  }
  if (slot === 'consegna') {
    return rows.find((row) => row.key === 'consegna') || null;
  }
  return null;
};

const inferTrackingCapabilities = (percorsi = [], expectedPrograms = 0) => {
  const rows = percorsi.flatMap((percorso) => buildStepRowsForPercorso(percorso));
  const declaredTotal = percorsi.reduce((max, percorso) => {
    const total = Number(percorso?.sequenceTotal);
    return Number.isFinite(total) && total > max ? total : max;
  }, 0);
  const indexedTotal = percorsi.reduce((max, percorso, idx) => {
    const parsedIndex = parseSequenceIndex(percorso?.sequenceIndex);
    return Math.max(max, parsedIndex || idx + 1);
  }, 0);
  const orderedPrograms = Number(expectedPrograms);
  return {
    totalPrograms: Math.max(
      declaredTotal,
      indexedTotal,
      percorsi.length || 0,
      Number.isFinite(orderedPrograms) && orderedPrograms > 0 ? orderedPrograms : 0
    ),
    hasNutritional: rows.some(
      (row) => row.key === 'consulenza' && normalizeConsulenzaType(row.step?.consulenzaType) === 'nutrizionale'
    ),
    hasTechnical: rows.some(
      (row) => row.key === 'consulenza' && normalizeConsulenzaType(row.step?.consulenzaType) === 'tecnica'
    ),
  };
};

const isStepExpectedForCapabilities = (capabilities, programIndex, stepSlot) => {
  const totalPrograms = Number(capabilities?.totalPrograms) || 1;
  if (programIndex > totalPrograms) return false;
  if (stepSlot === 'questionario') return programIndex === 1;
  if (stepSlot === 'consulenza_nutrizionale') return programIndex === 1 && !!capabilities?.hasNutritional;
  if (stepSlot === 'consulenza_tecnica') return !!capabilities?.hasTechnical;
  if (stepSlot === 'consegna') return true;
  if (stepSlot === 'check_finale') return true;
  return false;
};

const buildTrackingStepCell = (base, status, metaOverride = '') => {
  const diff = getDayDiffFromToday(base.plannedAt);
  let label = '—';
  let meta = metaOverride || '';

  if (status === 'complete') {
    label = 'Fatto';
    meta = base.doneAt ? formatStepDateLabel(base.doneAt) : meta;
  } else if (status === 'overdue') {
    label = 'Ritardo';
    meta = meta || formatDayDiffLabel(diff);
  } else if (status === 'today') {
    label = 'Oggi';
    meta = meta || formatStepDateLabel(base.plannedAt);
  } else if (status === 'on_track') {
    label = 'In linea';
    meta = meta || formatDayDiffLabel(diff);
  } else if (status === 'todo') {
    label = 'Da fare';
    meta = meta || 'senza data';
  } else if (status === 'waiting') {
    label = 'Attesa';
  } else if (status === 'blocked') {
    label = 'Fermo';
  } else if (status === 'not_applicable') {
    label = 'N/D';
  }

  const title = [
    base.programLabel,
    base.stepLabel,
    `Stato: ${label}`,
    base.doneAt ? `Completato il ${formatStepDateLabel(base.doneAt)}` : '',
    base.plannedAt && status !== 'complete' ? `Previsto il ${formatStepDateLabel(base.plannedAt)}` : '',
    meta,
  ]
    .filter(Boolean)
    .join(' • ');

  return {
    ...base,
    status,
    label,
    meta,
    title,
  };
};

const buildMissingProgramTracking = (programDef, capabilities, previousProgram = null) => {
  const shouldExist = programDef.index <= (Number(capabilities?.totalPrograms) || 1);
  const blockedByPrevious = shouldExist && !!previousProgram && !previousProgram.complete;
  const pendingCreation = shouldExist && !blockedByPrevious;
  const steps = {};

  programDef.steps.forEach((stepDef) => {
    const expected = isStepExpectedForCapabilities(capabilities, programDef.index, stepDef.slot);
    let status = 'not_applicable';
    let meta = '';
    if (expected && blockedByPrevious) {
      status = 'blocked';
      meta = 'prog. precedente';
    } else if (expected && pendingCreation) {
      status = 'waiting';
      meta = 'programma non creato';
    }

    steps[stepDef.slot] = buildTrackingStepCell(
      {
        programLabel: `${programDef.label} • TOP`,
        stepLabel: stepDef.label,
        available: false,
        done: false,
        doneAt: null,
        plannedAt: null,
        adminApproved: false,
        dailyState: '',
      },
      status,
      meta
    );
  });

  return {
    exists: false,
    complete: false,
    programIndex: programDef.index,
    programLabel: `${programDef.label} • TOP`,
    steps,
  };
};

const buildTopProgramTracking = (percorso, programDef, capabilities, lockReason = null, previousProgram = null) => {
  if (!percorso) {
    return buildMissingProgramTracking(programDef, capabilities, previousProgram);
  }

  const rows = buildStepRowsForPercorso(percorso);
  const programLabel = String(percorso?.title || percorso?.productName || 'Programma TOP').trim() || 'Programma TOP';
  const blockedByPreviousProgram = lockReason === 'sequence' || lockReason === 'previous_group';
  const rawSteps = programDef.steps.map((stepDef) => {
    const row = resolveTrackingRowForSlot(rows, stepDef.slot);
    const expected = isStepExpectedForCapabilities(capabilities, programDef.index, stepDef.slot);
    return {
      slot: stepDef.slot,
      stepLabel: stepDef.label,
      programLabel,
      expected,
      available: !!row,
      done: !!row?.isDone,
      doneAt: row?.step?.doneAt || (row?.isDone ? row?.step?.plannedAt || null : null),
      plannedAt: row?.step?.plannedAt || null,
      adminApproved: row?.step?.adminStatus === 'approved',
      dailyState: resolveStepAdminDailyState(row?.step),
      isLockedByConsegna: !!row?.isLockedByConsegna,
    };
  });

  const firstPendingIndex = rawSteps.findIndex((step) => (step.expected || step.available) && step.available && !step.done);
  const steps = {};

  rawSteps.forEach((step, index) => {
    let status = 'not_applicable';
    let meta = '';

    if (!step.expected && !step.available) {
      status = 'not_applicable';
    } else if (step.done) {
      status = 'complete';
    } else if (blockedByPreviousProgram) {
      status = 'blocked';
      meta = 'prog. precedente';
    } else if (step.isLockedByConsegna) {
      status = 'waiting';
      meta = 'attende consegna';
    } else if (firstPendingIndex !== -1 && index > firstPendingIndex && step.available) {
      status = 'waiting';
      meta = 'step precedente';
    } else if (step.available) {
      const diff = getDayDiffFromToday(step.plannedAt);
      if (diff == null) status = 'todo';
      else if (diff < 0) status = 'overdue';
      else if (diff === 0) status = 'today';
      else status = 'on_track';
    } else if (step.expected) {
      status = 'waiting';
      meta = 'step assente';
    }

    steps[step.slot] = buildTrackingStepCell(step, status, meta);
  });

  return {
    exists: true,
    complete: isPercorsoCompleteForLocking(percorso),
    programIndex: programDef.index,
    programLabel,
    steps,
  };
};

const parseTopSequenceFromText = (value) => {
  const text = String(value || '').toLowerCase();
  if (!text) return { index: 0, total: 0 };

  const fractionMatch = text.match(/(?:percorso|prog(?:ramma)?\.?)?\s*(\d+)\s*\/\s*(\d+)/i);
  if (fractionMatch) {
    const index = Number(fractionMatch[1]);
    const total = Number(fractionMatch[2]);
    return {
      index: Number.isFinite(index) && index > 0 ? index : 0,
      total: Number.isFinite(total) && total > 0 ? total : 0,
    };
  }

  const fcMatch = text.match(/\bfc\s*(\d+)\b/i) || text.match(/\bfc(\d+)\b/i);
  if (fcMatch) {
    const total = Number(fcMatch[1]);
    return { index: 0, total: Number.isFinite(total) && total > 0 ? total : 0 };
  }

  const programsMatch = text.match(/\b(\d+)\s*programmi\b/i);
  if (programsMatch) {
    const total = Number(programsMatch[1]);
    return { index: 0, total: Number.isFinite(total) && total > 0 ? total : 0 };
  }

  return { index: 0, total: 0 };
};

const resolveTopPercorsoSequenceInfo = (percorso = {}) => {
  const fromTitle = parseTopSequenceFromText(percorso?.title);
  const fromProduct = parseTopSequenceFromText(percorso?.productName);
  const rawIndex = parseSequenceIndex(percorso?.sequenceIndex);
  const rawTotal = Number(percorso?.sequenceTotal);

  return {
    index: rawIndex || fromTitle.index || fromProduct.index || 0,
    total: Math.max(
      Number.isFinite(rawTotal) && rawTotal > 0 ? rawTotal : 0,
      fromTitle.total || 0,
      fromProduct.total || 0
    ),
  };
};

const getTopGroupProgramTotal = (percorsi = [], expectedPrograms = 0) => {
  const list = Array.isArray(percorsi) ? percorsi : [];
  const expectedTotal = Number(expectedPrograms);
  const explicitTotal = list.reduce((max, percorso) => {
    const info = resolveTopPercorsoSequenceInfo(percorso);
    return Math.max(max, info.total || 0, info.index || 0);
  }, 0);

  if (explicitTotal > 0) return explicitTotal;
  if (Number.isFinite(expectedTotal) && expectedTotal > 0 && expectedTotal === list.length) {
    return expectedTotal;
  }
  return list.length > 1 ? list.length : 0;
};

const isTopGroupCompleted = (group = {}, expectedPrograms = 0) => {
  const sorted = [...(group?.percorsi || [])].sort(sortPercorsiBySequence);
  const totalPrograms = getTopGroupProgramTotal(sorted, expectedPrograms);
  if (!totalPrograms) return false;

  const percorsiByIndex = new Map();
  sorted.forEach((percorso, idx) => {
    const info = resolveTopPercorsoSequenceInfo(percorso);
    const programIndex = info.index || idx + 1;
    if (!percorsiByIndex.has(programIndex)) {
      percorsiByIndex.set(programIndex, percorso);
    }
  });

  const lastProgram = percorsiByIndex.get(totalPrograms);
  return !!lastProgram && hasConsegnaDone(lastProgram.steps);
};

const isTopGroupCycleCandidate = (group = {}, expectedPrograms = 0) =>
  getTopGroupProgramTotal(group?.percorsi || [], expectedPrograms) > 0;

const resolvePercorsoServiceTier = (percorso = {}) => {
  if (matchesTopPercorso(percorso)) return 'top';
  const candidates = [percorso?.productName, percorso?.title];
  const normalizedCandidates = candidates.map((candidate) => normalizeSkuKey(candidate));
  const hasPlusMatch = normalizedCandidates.some((normalized) => {
    return normalized.includes('plus');
  });
  if (hasPlusMatch) return 'plus';
  if (normalizedCandidates.some((normalized) => normalized.includes('basic'))) {
    return 'basic';
  }
  return 'other';
};

const resolveGroupServiceTier = (group = {}) => {
  const tiers = (group?.percorsi || []).map(resolvePercorsoServiceTier).filter(Boolean);
  if (tiers.includes('top')) return 'top';
  if (tiers.includes('plus')) return 'plus';
  if (tiers.includes('basic')) return 'basic';
  return tiers.length ? 'other' : '';
};

const isTopDowngradeTier = (tier) => tier === 'plus' || tier === 'basic';

const buildTopLifecycleStats = (
  groups = [],
  sequentialLocks = {},
  previousGroupLocks = {}
) => {
  const serviceGroups = groups
    .map((group) => ({
      ...group,
      serviceTier: resolveGroupServiceTier(group),
    }))
    .filter((group) => group.serviceTier);

  if (!serviceGroups.length) {
    return {
      activeServiceGroupId: '',
      activeServiceTier: '',
      nextServiceTier: '',
      hasPendingTopRenewal: false,
      hasPendingDowngrade: false,
      hasPendingPlusDowngrade: false,
      hasPendingBasicDowngrade: false,
      automaticTopHistory: false,
    };
  }

  const activeServiceGroup =
    serviceGroups.find((group) =>
      group.percorsi.some((percorso) => {
        const lockReason = getPercorsoLockReason(percorso, sequentialLocks, previousGroupLocks);
        return !lockReason && !isPercorsoFullyCompleted(percorso);
      })
    ) || serviceGroups[0];

  const chronologicalGroups = [...serviceGroups].sort((a, b) =>
    String(a?.anchor || '').localeCompare(String(b?.anchor || ''))
  );
  const activeIndex = chronologicalGroups.findIndex(
    (group) => group.id === activeServiceGroup?.id
  );
  const previousGroups = activeIndex > 0
    ? chronologicalGroups.slice(0, activeIndex)
    : [];
  const previousTopGroup = [...previousGroups]
    .reverse()
    .find((group) => group.serviceTier === 'top') || null;
  const nextServiceGroup = activeIndex >= 0
    ? chronologicalGroups[activeIndex + 1] || null
    : null;
  const activeTier = activeServiceGroup?.serviceTier || '';
  const nextTier = nextServiceGroup?.serviceTier || '';

  return {
    activeServiceGroupId: activeServiceGroup?.id || '',
    activeServiceTier: activeTier,
    nextServiceTier: nextTier,
    hasPendingTopRenewal: activeTier === 'top' && nextTier === 'top',
    hasPendingDowngrade: activeTier === 'top' && isTopDowngradeTier(nextTier),
    hasPendingPlusDowngrade: activeTier === 'top' && nextTier === 'plus',
    hasPendingBasicDowngrade: activeTier === 'top' && nextTier === 'basic',
    automaticTopHistory:
      isTopDowngradeTier(activeTier) &&
      Boolean(previousTopGroup),
  };
};

const buildTopCycleStats = (groups = [], selectedGroupId = '', expectedPrograms = 0) => {
  const chronologicalGroups = [...groups].sort((a, b) =>
    String(a?.anchor || '').localeCompare(String(b?.anchor || ''))
  );
  const qualifiedGroups = chronologicalGroups.filter(
    (group) => group.id === selectedGroupId || isTopGroupCycleCandidate(group, expectedPrograms)
  );
  const cycleGroups = qualifiedGroups.length ? qualifiedGroups : chronologicalGroups;
  const cycleCount = cycleGroups.length;
  const completedCycleCount = cycleGroups.filter((group) => isTopGroupCompleted(group, expectedPrograms)).length;
  const activeIndex = cycleGroups.findIndex((group) => group.id === selectedGroupId);
  const activeGroup = activeIndex >= 0 ? cycleGroups[activeIndex] : null;
  const completedPreviousCycleCount = activeIndex > 0
    ? cycleGroups
        .slice(0, activeIndex)
        .filter((group) => isTopGroupCompleted(group, expectedPrograms)).length
    : 0;
  return {
    cycleCount,
    completedCycleCount,
    completedPreviousCycleCount,
    currentCycleCompleted: activeGroup ? isTopGroupCompleted(activeGroup, expectedPrograms) : false,
    activeCycleNumber: activeIndex >= 0 ? activeIndex + 1 : cycleCount || 0,
    hasRenewed: activeIndex > 0 && cycleCount > 1,
  };
};

const buildEmptyTopTracking = (expectedPrograms = 0) => {
  const trackingPrograms = buildTrackingPrograms(expectedPrograms);
  const capabilities = {
    totalPrograms: trackingPrograms.length,
    hasNutritional: false,
    hasTechnical: false,
  };
  const programs = {};
  let previousProgram = null;

  trackingPrograms.forEach((programDef) => {
    const summary = buildMissingProgramTracking(programDef, capabilities, previousProgram);
    programs[programDef.index] = summary;
    previousProgram = summary;
  });

  return {
    hasTop: trackingPrograms.length > 0,
    totalPrograms: trackingPrograms.length,
    programs,
    cycleCount: 0,
    completedCycleCount: 0,
    completedPreviousCycleCount: 0,
    currentCycleCompleted: false,
    activeCycleNumber: 0,
    hasRenewed: false,
    activeServiceGroupId: '',
    activeServiceTier: '',
    nextServiceTier: '',
    hasPendingTopRenewal: false,
    hasPendingDowngrade: false,
    hasPendingPlusDowngrade: false,
    hasPendingBasicDowngrade: false,
    automaticTopHistory: false,
  };
};

const buildTopTrackingSummary = (rows = [], expectedPrograms = 0) => {
  const groups = buildOrderedPercorsoGroups(rows);
  if (!groups.length) return buildEmptyTopTracking(expectedPrograms);

  const sequentialLocks = buildSequentialLocks(groups);
  const previousGroupLocks = buildPreviousGroupLocks(groups);
  const topGroups = groups
    .map((group) => ({
      ...group,
      percorsi: (group?.percorsi || []).filter((percorso) => matchesTopPercorso(percorso)),
    }))
    .filter((group) => group.percorsi.length);

  if (!topGroups.length) return buildEmptyTopTracking(expectedPrograms);

  const lifecycleStats = buildTopLifecycleStats(
    groups,
    sequentialLocks,
    previousGroupLocks
  );
  const activeTopGroup = lifecycleStats.activeServiceTier === 'top'
    ? topGroups.find((group) => group.id === lifecycleStats.activeServiceGroupId)
    : null;
  const selectedGroup =
    activeTopGroup ||
    topGroups.find((group) =>
      group.percorsi.some((percorso) => {
        const lockReason = getPercorsoLockReason(percorso, sequentialLocks, previousGroupLocks);
        return !lockReason && !isPercorsoFullyCompleted(percorso);
      })
    ) ||
    topGroups[0];
  const cycleStats = buildTopCycleStats(topGroups, selectedGroup?.id || '', expectedPrograms);

  const orderedPercorsi = [...(selectedGroup?.percorsi || [])].sort(sortPercorsiBySequence);
  const capabilities = inferTrackingCapabilities(orderedPercorsi, expectedPrograms);
  const trackingPrograms = buildTrackingPrograms(capabilities.totalPrograms);
  const percorsiByIndex = new Map();

  orderedPercorsi.forEach((percorso, idx) => {
    const parsedIndex = parseSequenceIndex(percorso?.sequenceIndex);
    const programIndex = parsedIndex || idx + 1;
    if (!percorsiByIndex.has(programIndex)) {
      percorsiByIndex.set(programIndex, percorso);
    }
  });

  const programs = {};
  let previousProgram = null;

  trackingPrograms.forEach((programDef) => {
    const percorso = percorsiByIndex.get(programDef.index) || null;
    const lockReason = percorso
      ? getPercorsoLockReason(percorso, sequentialLocks, previousGroupLocks)
      : null;
    const summary = buildTopProgramTracking(percorso, programDef, capabilities, lockReason, previousProgram);
    programs[programDef.index] = summary;
    previousProgram = summary;
  });

  return {
    hasTop: true,
    totalPrograms: trackingPrograms.length,
    programs,
    ...cycleStats,
    ...lifecycleStats,
  };
};

const resolveTopProgressStatus = (tracking) => {
  let latestStatus = '';
  const programs = Object.entries(tracking?.programs || {})
    .sort(([leftIndex], [rightIndex]) => Number(leftIndex) - Number(rightIndex));
  for (const [programIndex, program] of programs) {
    if (!program?.exists) continue;
    const stepDefinitions = Number(programIndex) === 1
      ? FIRST_TRACKING_PROGRAM_STEPS
      : FOLLOWUP_TRACKING_PROGRAM_STEPS;
    // Follow the displayed sequence; future waiting/blocked steps do not advance it.
    for (const { slot } of stepDefinitions) {
      const step = program.steps?.[slot];
      if (!step?.available) continue;
      if (step.done || step.status === 'complete' || step.status === 'on_track' || step.status === 'today') {
        latestStatus = 'on_track';
      } else if (step.status === 'overdue') {
        latestStatus = 'overdue';
      } else if (step.status === 'todo') {
        latestStatus = '';
      }
    }
  }
  return latestStatus;
};

export default {
  directives: {
    staffTopTooltip,
  },
  components: {
    SidebarComponent,
  },
  setup() {
    const users = ref([]);
    const isLoading = ref(false);
    const isTrackingLoading = ref(false);
    const trackingLoadedUsers = ref(0);
    const loadingMessage = ref('Caricamento degli ordini TOP…');
    const loadError = ref('');
    const trackingError = ref('');
    let loadController = null;
    const currentPage = ref(1);
    const pageSize = ref(TOP_LIST_DEFAULT_PAGE_SIZE);
    const canAccessBackfill = ref(false);
    const showExpiringOnly = ref(false);
    const showUnsavedOnly = ref(false);
    const showRenewalOnly = ref(false);
    const topListView = ref('active');
    const expiringWindowDays = ref(30);
    const searchQuery = ref('');
    const checkFilter = ref('all');
    const progressFilter = ref('all');
    const filtersOpen = ref(true);
    const showCreateConversationModal = ref(false);
    const newConversation = ref({ title: '', message: '' });
    const isCreatingConversation = ref(false);
    let pendingConversation = null;
    const showDeliveryMessagesModal = ref(false);
    const showFullMessage = ref([]);
    const savingContactFlags = reactive({});
    const savingNoteFlags = reactive({});
    const savingVisibilityFlags = reactive({});
    const noteSaveTimers = new Map();
    const noteSaveRequestIds = new Map();
    const deliveryMessages = ref([
      {
        title: 'MESSAGGIO POST ACQUISTO - PROGRAMMA COMPLETO:',
        content: `Ciaooo\n\nbenvenuta in Fusco Fit! 🎉\n\nstiamo per costruire insieme il tuo percorso personalizzato.\n\nEcco come funziona, passo dopo passo:\n\n📋 Prossimi Step\n\n<strong>1. Scarica la nostra app.</strong>\n📲 Fusco Fit Connect (logo nero) → comunicazioni, assistenza, piano alimentare e allenamenti sono tutti nella stessa app.\n🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.\n📝 Registrati usando la stessa email che ci hai fornito all’acquisto.\n\n<strong>2. Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>\n📧 È indispensabile per costruire il tuo piano.\n🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.\n📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.\n\n<strong>3. Video call con la nutrizionista</strong>\nDopo che il tuo questionario sarà approvato, verrai contattata per fissare l’appuntamento in videocall, se non riesci a rispondere richiamaci appena puoi.\nLa call è indispensabile per perfezionare il piano alimentare e per ricevere l’allenamento.\n\n<strong>4. Se il tuo piano prevede una call tecnica (servizio plus)</strong>\nRiceverai un messaggio in app Fusco Fit Connect (logo nero) per fissare la videocall.\n📅 In quel momento ti chiederemo di indicarci le tue fasce orarie di disponibilità per prenotarla, chiaramente dopo la consegna delle programmazioni.\n\n<strong>5. Consegna del programma</strong>\nNei 2 giorni lavorativi successivi alla call con la nutrizionista prepareremo il tuo piano.\n📲 La consegna sarà pronta quando riceverai il messaggio di conferma in Fusco Fit Connect (logo nero).\n📂 Il piano alimentare sarà nella sezione Alimentazione.\n💪 Il programma di allenamento sarà nella sezione Allenamenti della stessa app.\n\n<strong>➡️ Dopo la consegna</strong>\nPotrai iniziare subito a seguire il tuo percorso.\nPer dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” su app Fusco Fit Connect (logo nero), mentre per dubbi alimentari avrai a disposizione 2 ticket al mese su “assistenza nutrizionale”.\n\n<strong>📌 Nota importante sulle call tecniche</strong>\nLa call tecnica può essere utilizzata solo all’interno del programma in corso.\nEsempio: se hai acquistato 6 programmi → avrai diritto a 1 call per ogni programma.\n👉 Una volta terminato il singolo programma, anche la call associata scade se non è stata utilizzata.\nPrima di effettuare la videocall segnati ogni dubbio che hai sulla scheda, così li analizzeremo INSIEME❤️\n\n<strong>💪🏻Orari assistenza💪🏻</strong>\nIl nostro team è disponibile:\n🕘 Lunedì – Venerdì dalle 9:00 alle 19:00\n🕙 Sabato dalle 10:00 alle 13:00`
      },
      {
        title: 'MESSAGGIO POST ACQUISTO - SOLO ALLENAMENTO:',
        content: `Ciaooo\n\nbenvenuta in Fusco Fit! 🎉\n\nstiamo per costruire insieme il tuo percorso personalizzato.\n\nEcco come funziona, passo dopo passo:\n\n📋 Prossimi Step\n\n<strong>1. Scarica la nostra app.</strong>\n📲 Fusco Fit Connect (logo nero) → comunicazioni, assistenza e allenamenti sono tutti nella stessa app.\n🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.\n📝 Registrati usando la stessa email che ci hai fornito all’acquisto.\n\n<strong>2.Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>\n📧 È indispensabile per costruire il tuo piano.\n🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.\n📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.\n\n<strong>3.Se il tuo piano prevede una call tecnica (servizio plus)</strong>\nRiceverai un messaggio in app Fusco Fit Connect (logo nero) per fissare la videocall.\n📅 In quel momento ti chiederemo di indicarci le tue fasce orarie di disponibilità per prenotarla, chiaramente dopo la consegna delle programmazioni.\n\n<strong>4.Consegna del programma</strong>\n📲 La consegna sarà pronta quando riceverai il messaggio di conferma in Fusco Fit Connect (logo nero).\n💪 Il tuo programma di allenamento sarà caricato nella sezione Allenamenti della stessa app.\n\n<strong>➡️ Dopo la consegna</strong>\nPotrai iniziare subito a seguire il tuo percorso.\nPer dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” su app Fusco Fit Connect (logo nero)\n\n<strong>📌 Nota importante sulle call tecniche</strong>\nLa call tecnica può essere utilizzata solo all’interno del programma in corso.\nEsempio: se hai acquistato 6 programmi → avrai diritto a 1 call per ogni programma.\n👉 Una volta terminato il singolo programma, anche la call associata scade se non è stata utilizzata.\nPrima di effettuare la videocall segnati ogni dubbio che hai sulla scheda, così li analizzeremo INSIEME❤️\n\n<strong>💪🏻Orari assistenza💪🏻</strong>\nIl nostro team è disponibile:\n🕘 Lunedì – Venerdì dalle 9:00 alle 19:00\n🕙 Sabato dalle 10:00 alle 13:00`
      },
      {
        title: 'MESSAGGIO POST ACQUISTO - SOLO DIETA:',
        content: `Ciaooooo\n\nbenvenuta in Fusco Fit! 🎉\n\nstiamo per costruire insieme il tuo percorso personalizzato.\n\nEcco come funziona, passo dopo passo:\n\n📋 Prossimi Step\n\n<strong>1. Scarica la nostra app.</strong>\n📲 Fusco Fit Connect (logo nero) → utile per le comunicazioni, assistenza e piano alimentare.\n🔍 Cerca “Fusco Fit Connect” nello store del tuo telefono e scaricala.\n📝 Registrati usando la stessa email che ci hai fornito all’acquisto.\n\n<strong>2. Compila il questionario che riceverai via email (se non lo hai già compilato).</strong>\n📧 È indispensabile per costruire il tuo piano.\n🖊️ Più sarai precisa (soprattutto nelle note libere), più riusciremo a personalizzare il tuo percorso.\n📬 Dopo l’invio, potresti ricevere via mail una richiesta di approfondimento: controlla spesso la posta.\n\n<strong>3. Video call con la nutrizionista</strong>\nDopo che il tuo questionario sarà approvato, verrai contattata per fissare l’appuntamento in videocall, se non riesci a rispondere richiamaci appena puoi.\nLa call è indispensabile per perfezionare il piano alimentare.\n\n<strong>5. Consegna del programma</strong>\nNei 2 giorni lavorativi successivi alla call con la nutrizionista prepareremo il tuo piano.\n📲 La consegna sarà pronta quando riceverai il messaggio di conferma in app Fusco Fit Connect (logo nero).\n📂 Il tuo piano alimentare sarà nell’app Fusco Fit Connect (logo nero).\n\n<strong>➡️ Dopo la consegna</strong>\nPotrai iniziare subito a seguire il tuo percorso.\nPer dubbi o chiarimenti, scrivici illimitatamente su “assistenza tecnica” su app Fusco Fit Connect (logo nero), mentre per dubbi alimentari avrai a disposizione 2 ticket al mese su “assistenza nutrizionale”.\n\n<strong>💪🏻Orari assistenza💪🏻</strong>\nIl nostro team è disponibile:\n🕘 Lunedì – Venerdì dalle 9:00 alle 19:00\n🕙 Sabato dalle 10:00 alle 13:00`
      },
    ]);

    const selectedUserId = ref(null);

    const db = getFirestore();
    const router = useRouter();
    const auth = getAuth();

    const updateBackfillAccess = (user) => {
      canAccessBackfill.value = Boolean(
        user &&
        user.uid === TOP_BACKFILL_PRIV_UID &&
        normalizeEmail(user.email) === TOP_BACKFILL_PRIV_EMAIL
      );
    };

    updateBackfillAccess(auth.currentUser);
    const unsubscribe = auth.onAuthStateChanged(updateBackfillAccess);
    onUnmounted(() => {
      loadController?.abort();
      unsubscribe();
      noteSaveTimers.forEach((timerId) => window.clearTimeout(timerId));
      noteSaveTimers.clear();
      noteSaveRequestIds.clear();
    });

    const goToBackfill = () => {
      router.push({ path: '/backfill-top-sku' });
    };

    const clearExclusiveFilters = () => {
      checkFilter.value = 'all';
      showExpiringOnly.value = false;
      showUnsavedOnly.value = false;
      showRenewalOnly.value = false;
    };

    const toggleExclusiveBooleanFilter = (targetRef) => {
      const wasActive = targetRef.value;
      clearExclusiveFilters();
      targetRef.value = !wasActive;
    };

    const toggleExpiringOnly = () => {
      toggleExclusiveBooleanFilter(showExpiringOnly);
    };

    const toggleUnsavedOnly = () => {
      toggleExclusiveBooleanFilter(showUnsavedOnly);
    };

    const toggleRenewalOnly = () => {
      const wasActive = topListView.value === 'active' && showRenewalOnly.value;
      topListView.value = 'active';
      clearExclusiveFilters();
      showRenewalOnly.value = !wasActive;
    };

    const setTopListView = (view) => {
      const nextView = view === 'history' ? 'history' : 'active';
      if (topListView.value === nextView) return;
      topListView.value = nextView;
      clearExclusiveFilters();
    };

    const handleCheckFilterChange = () => {
      if (checkFilter.value === 'all') return;
      showExpiringOnly.value = false;
      showUnsavedOnly.value = false;
      showRenewalOnly.value = false;
    };

    const resetQuickFilters = () => {
      searchQuery.value = '';
      progressFilter.value = 'all';
      clearExclusiveFilters();
      expiringWindowDays.value = 30;
    };

    const updateUserLocally = (userId, patch = {}) => {
      users.value = users.value.map((entry) =>
        entry.uid === userId
          ? {
              ...entry,
              ...patch,
            }
          : entry
      );
    };

    const resolveUserVisibilityOverride = (user) =>
      normalizeTopListVisibilityOverride(user?.[TOP_LIST_VISIBILITY_OVERRIDE_FIELD]);

    const isAutomaticTopHistory = (user) =>
      Boolean(user?._topTracking?.automaticTopHistory);

    const isTopHistoryUser = (user) => {
      const visibilityOverride = resolveUserVisibilityOverride(user);
      if (visibilityOverride === TOP_LIST_VISIBILITY_ARCHIVE) return true;
      if (visibilityOverride === TOP_LIST_VISIBILITY_ACTIVE) return false;
      return isAutomaticTopHistory(user);
    };

    const hasTopVisibilityOverride = (user) =>
      resolveUserVisibilityOverride(user) !== TOP_LIST_VISIBILITY_AUTO;

    const persistTopVisibilityOverride = async (user, nextOverride, reason = '') => {
      const userId = String(user?.uid || '').trim();
      if (!userId) return;

      const normalizedOverride = normalizeTopListVisibilityOverride(nextOverride);
      const previousValues = {
        [TOP_LIST_VISIBILITY_OVERRIDE_FIELD]:
          user?.[TOP_LIST_VISIBILITY_OVERRIDE_FIELD] || null,
        [TOP_LIST_VISIBILITY_OVERRIDE_AT_FIELD]:
          user?.[TOP_LIST_VISIBILITY_OVERRIDE_AT_FIELD] || null,
        [TOP_LIST_VISIBILITY_OVERRIDE_BY_FIELD]:
          user?.[TOP_LIST_VISIBILITY_OVERRIDE_BY_FIELD] || null,
        [TOP_LIST_VISIBILITY_OVERRIDE_REASON_FIELD]:
          user?.[TOP_LIST_VISIBILITY_OVERRIDE_REASON_FIELD] || null,
      };
      const nowIso = new Date().toISOString();
      const isAutomatic = normalizedOverride === TOP_LIST_VISIBILITY_AUTO;
      const nextPatch = {
        [TOP_LIST_VISIBILITY_OVERRIDE_FIELD]: isAutomatic ? null : normalizedOverride,
        [TOP_LIST_VISIBILITY_OVERRIDE_AT_FIELD]: isAutomatic ? null : nowIso,
        [TOP_LIST_VISIBILITY_OVERRIDE_BY_FIELD]:
          isAutomatic ? null : auth.currentUser?.uid || null,
        [TOP_LIST_VISIBILITY_OVERRIDE_REASON_FIELD]:
          isAutomatic ? null : String(reason || '').trim(),
      };

      updateUserLocally(userId, nextPatch);
      savingVisibilityFlags[userId] = true;

      try {
        await updateDoc(doc(db, 'users', userId), {
          ...nextPatch,
          updatedAt: nowIso,
        });
      } catch (error) {
        console.error('Errore durante il salvataggio della visibilità TOP:', error);
        updateUserLocally(userId, previousValues);
        alert('Errore durante il salvataggio dello stato nello Storico TOP.');
      } finally {
        savingVisibilityFlags[userId] = false;
      }
    };

    const moveUserToTopHistory = async (user) => {
      const defaultReason = String(
        user?.[TOP_LIST_VISIBILITY_OVERRIDE_REASON_FIELD] || ''
      ).trim();
      const reason = window.prompt(
        'Motivo dello spostamento manuale nello Storico TOP (facoltativo):',
        defaultReason
      );
      if (reason === null) return;
      await persistTopVisibilityOverride(
        user,
        TOP_LIST_VISIBILITY_ARCHIVE,
        reason || 'Archiviazione manuale'
      );
    };

    const restoreUserToActiveTop = async (user) => {
      const confirmed = window.confirm(
        'Forzare questa cliente nella vista TOP attiva? La regola automatica resterà sospesa finché non verrà ripristinata.'
      );
      if (!confirmed) return;
      await persistTopVisibilityOverride(
        user,
        TOP_LIST_VISIBILITY_ACTIVE,
        'Ripristino manuale tra i TOP attivi'
      );
    };

    const resetTopVisibilityOverride = async (user) => {
      const confirmed = window.confirm(
        'Ripristinare la gestione automatica della visibilità TOP?'
      );
      if (!confirmed) return;
      await persistTopVisibilityOverride(user, TOP_LIST_VISIBILITY_AUTO);
    };

    const updateUserContactSavedLocally = (userId, nextValue) => {
      updateUserLocally(userId, {
        [CONTACT_SAVED_FIELD]: nextValue,
      });
    };

    const toggleContactSaved = async (user, nextValue) => {
      const userId = String(user?.uid || '').trim();
      if (!userId) return;

      const previousValue = Boolean(user?.[CONTACT_SAVED_FIELD]);
      updateUserContactSavedLocally(userId, nextValue);
      savingContactFlags[userId] = true;

      try {
        await updateDoc(doc(db, 'users', userId), {
          [CONTACT_SAVED_FIELD]: nextValue,
          updatedAt: new Date().toISOString(),
        });
      } catch (error) {
        console.error('Errore durante il salvataggio del flag contatto:', error);
        updateUserContactSavedLocally(userId, previousValue);
        alert('Errore durante il salvataggio del flag contatto.');
      } finally {
        savingContactFlags[userId] = false;
      }
    };

    const clearTopListNoteSave = (userId) => {
      const currentTimer = noteSaveTimers.get(userId);
      if (currentTimer) {
        window.clearTimeout(currentTimer);
      }
      noteSaveTimers.delete(userId);
    };

    const persistTopListNote = async (user) => {
      const userId = String(user?.uid || '').trim();
      if (!userId) return;

      clearTopListNoteSave(userId);
      const nextValue = String(user?.[TOP_LIST_NOTE_FIELD] || '');
      const requestId = (noteSaveRequestIds.get(userId) || 0) + 1;
      noteSaveRequestIds.set(userId, requestId);
      savingNoteFlags[userId] = true;

      try {
        await updateDoc(doc(db, 'users', userId), {
          [TOP_LIST_NOTE_FIELD]: nextValue,
          updatedAt: new Date().toISOString(),
        });
      } catch (error) {
        console.error('Errore durante il salvataggio della nota TOP:', error);
        alert('Errore durante il salvataggio della nota.');
      } finally {
        if (noteSaveRequestIds.get(userId) === requestId) {
          savingNoteFlags[userId] = false;
        }
      }
    };

    const queueTopListNoteSave = (user, immediate = false) => {
      const userId = String(user?.uid || '').trim();
      if (!userId) return;

      clearTopListNoteSave(userId);
      if (immediate) {
        persistTopListNote(user);
        return;
      }

      const timerId = window.setTimeout(() => {
        persistTopListNote(user);
      }, 600);
      noteSaveTimers.set(userId, timerId);
    };

    const relativeCheckLabel = (user) => {
      const doneAt = toDateSafe(user?._latestCheckDoneAt);
      if (!doneAt) return '';

      const startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      const startOfCheckDay = new Date(doneAt.getTime());
      startOfCheckDay.setHours(0, 0, 0, 0);
      const diffDays = Math.round((startOfCheckDay.getTime() - startOfToday.getTime()) / DAY_IN_MS);

      if (diffDays === 0) return 'Oggi';
      if (diffDays === -1) return 'Ieri';
      if (diffDays === 1) return 'Domani';
      if (diffDays < 0) return `${Math.abs(diffDays)} gg fa`;
      return `Tra ${diffDays} gg`;
    };

    const formatDateTime = (value) => {
      const date = toDateSafe(value);
      if (!date) return '—';
      return date.toLocaleString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    };

    const checkDateTitle = (user) => {
      const dateLabel = formatDateTime(user?._latestCheckDoneAt);
      const programLabel = (user?._latestCheckProgramTitle || '').trim();
      return programLabel ? `${dateLabel} • ${programLabel}` : dateLabel;
    };

    const loadLatestChecksForUsers = async (userList, { readDocs, onChunkLoaded, onChunkFailed, signal }) => {
      const latestByUid = new Map();
      const diagnosticByUid = new Map();
      const trackingByUid = new Map();
      const expectedProgramsByUid = new Map(
        userList.map((user) => [
          String(user?.uid || '').trim(),
          Number(user?._topOrderProgramCount) || 0,
        ])
      );
      const userIds = Array.from(
        new Set(
          userList
            .map((user) => String(user?.uid || '').trim())
            .filter(Boolean)
        )
      );
      if (!userIds.length) {
        return { latestByUid, diagnosticByUid, trackingByUid };
      }

      const percorsiByUid = new Map();
      userIds.forEach((uid) => {
        diagnosticByUid.set(uid, createEmptyCheckDiagnostic());
        percorsiByUid.set(uid, []);
      });

      const mergeLatestCheck = (uid, nextMeta) => {
        if (!uid || !nextMeta) return;
        const current = latestByUid.get(uid);
        if (!current || nextMeta.doneAtMs > current.doneAtMs) {
          latestByUid.set(uid, nextMeta);
        }
      };

      const ensureDiagnostic = (uid) => {
        if (!uid) return createEmptyCheckDiagnostic();
        if (!diagnosticByUid.has(uid)) {
          diagnosticByUid.set(uid, createEmptyCheckDiagnostic());
        }
        return diagnosticByUid.get(uid);
      };

      await mapWithConcurrency(
        chunkList(userIds, TOP_UID_BATCH_SIZE),
        TOP_LIST_QUERY_CONCURRENCY,
        async (chunk) => {
          if (signal.aborted) return;
          try {
            const [uidSnap, userUidSnap] = await Promise.all([
              readDocs(query(collection(db, 'percorsi'), where('uid', 'in', chunk))),
              readDocs(query(collection(db, 'percorsi'), where('userUid', 'in', chunk))),
            ]);
            if (signal.aborted) return;
            const seenPercorsoIds = new Set();

            [uidSnap, userUidSnap].forEach((snap) => {
              snap.forEach((docSnap) => {
                if (seenPercorsoIds.has(docSnap.id)) return;
                seenPercorsoIds.add(docSnap.id);

                const data = docSnap.data() || {};
                const uid = String(data.uid || data.userUid || '').trim();
                if (!uid) return;
                const userPercorsi = percorsiByUid.get(uid) || [];
                userPercorsi.push({ id: docSnap.id, ...data });
                percorsiByUid.set(uid, userPercorsi);
                const diagnostic = ensureDiagnostic(uid);
                diagnostic.percorsiCount += 1;

                const steps = normalizeStepsArray(data.steps);
                if (!steps.length) {
                  diagnostic.percorsiWithoutSteps += 1;
                }

                steps.forEach((step, stepIndex) => {
                  if (stepKeyFromName(step?.name) !== 'check_finale') return;

                  diagnostic.checkStepsFound += 1;
                  if (step?.convertedFromQuestionario) {
                    diagnostic.convertedCheckSteps += 1;
                    return;
                  }

                  if (step?.done !== undefined && !step.done) {
                    diagnostic.incompleteCheckSteps += 1;
                    return;
                  }

                  const doneAt = toDateSafe(step?.doneAt);
                  if (!doneAt) {
                    diagnostic.invalidDoneAtCheckSteps += 1;
                    return;
                  }
                  const doneAtIso = doneAt.toISOString();
                  mergeLatestCheck(uid, {
                    key: buildLatestCheckKey(docSnap.id, stepIndex, doneAtIso),
                    doneAt: doneAtIso,
                    doneAtMs: doneAt.getTime(),
                    percorsoId: docSnap.id,
                    stepIndex,
                    programTitle: data.title || data.productName || null,
                  });
                });
              });
            });

            chunk.forEach((uid) => {
              trackingByUid.set(
                uid,
                buildTopTrackingSummary(
                  percorsiByUid.get(uid) || [],
                  expectedProgramsByUid.get(uid) || 0
                )
              );
            });

            if (typeof onChunkLoaded === 'function') {
              await onChunkLoaded(chunk, {
                latestByUid,
                diagnosticByUid,
                trackingByUid,
              });
            }
          } catch (error) {
            if (!signal.aborted) onChunkFailed(chunk, error);
          }
        }
      );

      return { latestByUid, diagnosticByUid, trackingByUid };
    };

    const sortTopUsers = (list = []) => [...list].sort((a, b) => {
      const orderDiff = (b?._topOrderTime || 0) - (a?._topOrderTime || 0);
      if (orderDiff !== 0) return orderDiff;

      const checkDiff = (b?._latestCheckDoneMs || 0) - (a?._latestCheckDoneMs || 0);
      if (checkDiff !== 0) return checkDiff;

      return resolveUserCreatedTime(b) - resolveUserCreatedTime(a);
    });

    const matchesSearch = (user) => {
      const queryValue = String(searchQuery.value || '').trim().toLowerCase();
      if (!queryValue) return true;
      const haystack = [
        user?.email,
        user?.name,
        user?.surname,
        user?._latestCheckProgramTitle,
      ]
        .map((value) => String(value || '').toLowerCase())
        .join(' ');
      return haystack.includes(queryValue);
    };

    const matchesCheckFilter = (user) => {
      if (checkFilter.value !== 'all' && (user?._topTrackingLoading || user?._topTrackingError)) return false;
      switch (checkFilter.value) {
        case 'with_check':
          return !!user?._latestCheckKey;
        case 'without_check':
          return !user?._latestCheckKey;
        default:
          return true;
      }
    };

    const loadTicketStatuses = async (userList, readDocs, signal) => {
      const ticketsCollection = collection(db, 'assistenzatecnica');
      const userIds = userList.map((user) => user.uid).filter(Boolean);
      if (!userIds.length) return;

      const ticketStatuses = {};
      const chunks = chunkList(userIds, TOP_CHUNK_SIZE);

      const snapshots = await mapWithConcurrency(
        chunks,
        TOP_LIST_QUERY_CONCURRENCY,
        (chunk) => readDocs(query(ticketsCollection, where('userId', 'in', chunk)))
      );
      snapshots.forEach((querySnapshot) => {
        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          ticketStatuses[data.userId] = data.status;
        });
      });

      if (signal.aborted) return;
      users.value = users.value.map((user) => ({
        ...user,
        ticketStatus: ticketStatuses[user.uid] || null,
      }));
    };

    const openInNewTab = (route) => {
      const resolved = router.resolve(route);
      window.open(resolved.href, '_blank', 'noopener');
    };

    const viewUserDetails = (userId) => {
      openInNewTab({ name: 'UserDetails', params: { userId: userId } });
    };

    const viewUserCommunications = (userId) => {
      openInNewTab({ name: 'UserComunicazioni', params: { userId: userId } });
    };

    const getCandidateUserIds = (user) => {
      if (!user) {
        return [];
      }
      if (typeof user === 'string') {
        return [user];
      }
      return [user.uid, user.userId, user.id].filter(Boolean);
    };

    const fetchTicketIdForUser = async (userIds) => {
      const candidateIds = Array.isArray(userIds) ? userIds : [userIds];
      const uniqueIds = Array.from(new Set(candidateIds.filter(Boolean)));
      if (!uniqueIds.length) {
        console.error('Errore: userId non definito');
        return null;
      }

      try {
        const ticketsRef = collection(db, 'assistenzatecnica');
        const q =
          uniqueIds.length === 1
            ? query(ticketsRef, where('userId', '==', uniqueIds[0]))
            : query(ticketsRef, where('userId', 'in', uniqueIds.slice(0, 10)));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const ticketDoc = querySnapshot.docs[0];
          return ticketDoc.id;
        }
        return null;
      } catch (error) {
        console.error('Errore nel recupero del ticketId:', error);
        return null;
      }
    };

    const viewTechnicalConversation = async (user) => {
      const candidateIds = getCandidateUserIds(user);
      const userId = candidateIds[0];
      if (!userId) {
        console.error('Errore: userId non definito');
        return;
      }

      const pendingTab = window.open('about:blank', '_blank');
      if (pendingTab) {
        pendingTab.opener = null;
      }

      try {
        const ticketId = await fetchTicketIdForUser(candidateIds);

        if (ticketId) {
          const route = {
            name: 'UserConversationTecnica',
            params: { userId, ticketId },
          };
          const resolved = router.resolve(route);
          if (pendingTab) {
            pendingTab.location.href = resolved.href;
          } else {
            openInNewTab(route);
          }
        } else {
          if (pendingTab) {
            pendingTab.close();
          }
          selectedUserId.value = userId;
          showCreateConversationModal.value = true;
        }
      } catch (error) {
        if (pendingTab) {
          pendingTab.close();
        }
        console.error('Errore durante il recupero della conversazione tecnica:', error);
      }
    };

    const closeCreateConversationModal = () => {
      showCreateConversationModal.value = false;
      newConversation.value = { title: '', message: '' };
      pendingConversation = null;
    };

    const createConversation = async () => {
      if (isCreatingConversation.value) return;
      const draft = newConversation.value;
      const userId = selectedUserId.value;
      const title = draft.title.trim();
      const content = draft.message.trim();
      if (!userId || !title || !content) {
        alert('Inserisci un titolo e un messaggio per la conversazione.');
        return;
      }
      const operatorId = getAuth().currentUser?.uid;
      if (!operatorId) {
        console.error("Errore: ID dell'operatore non trovato.");
        return;
      }
      const originalTitle = draft.title;
      const originalMessage = draft.message;
      const key = JSON.stringify([operatorId, userId, originalTitle, originalMessage]);
      if (pendingConversation?.key !== key) {
        pendingConversation = { key, payload: { userId, title, content, messageId: createTechnicalMessageId() } };
      }
      const request = pendingConversation;
      const isCurrentDraft = () => selectedUserId.value === userId && newConversation.value === draft
        && draft.title === originalTitle && draft.message === originalMessage;
      isCreatingConversation.value = true;
      try {
        const result = await createTechnicalTicket(request.payload);
        if (pendingConversation === request) pendingConversation = null;
        if (isCurrentDraft()) {
          alert(result.created === false ? 'Messaggio inviato nella conversazione esistente!' : 'Conversazione creata con successo!');
          closeCreateConversationModal();
        }
        return result;
      } catch (error) {
        console.error('Errore durante la creazione della conversazione:', error);
        if (isCurrentDraft()) alert('Errore durante la creazione della conversazione.');
      } finally {
        isCreatingConversation.value = false;
      }
    };

    const openDeliveryMessagesModal = () => {
      showFullMessage.value = deliveryMessages.value.map(() => false);
      showDeliveryMessagesModal.value = true;
    };

    const closeDeliveryMessagesModal = () => {
      showDeliveryMessagesModal.value = false;
    };

    const copyMessageToConversation = (content) => {
      const currentMessage = newConversation.value?.message;
      if (typeof currentMessage === 'string' && currentMessage.length > 0) {
        newConversation.value.message += '\n' + content;
      } else {
        newConversation.value.message = content;
      }

      closeDeliveryMessagesModal();
    };

    const truncateMessage = (message = '', index) => {
      if (showFullMessage.value[index]) {
        return message;
      }
      return message.length > 150 ? message.slice(0, 150) + '...' : message;
    };

    const toggleFullMessage = (index) => {
      showFullMessage.value[index] = !showFullMessage.value[index];
    };

    const formatDate = (value) => {
      if (!value) return '—';
      if (value && typeof value.toDate === 'function') {
        const date = value.toDate();
        return date.toLocaleDateString('it-IT');
      }
      if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? '—' : value.toLocaleDateString('it-IT');
      }
      if (typeof value === 'number') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? '—' : date.toLocaleDateString('it-IT');
      }
      if (typeof value === 'string') {
        const parsed = toDateSafe(value);
        return parsed ? parsed.toLocaleDateString('it-IT') : '—';
      }
      return '—';
    };

    const resolveTopTracking = (user) => user?._topTracking || null;

    const matchesProgressFilter = (user) => {
      if (progressFilter.value === 'all') return true;
      if (user?._topTrackingLoading || user?._topTrackingError) return false;
      return resolveTopProgressStatus(resolveTopTracking(user)) === progressFilter.value;
    };

    const buildUnavailableTrackingCell = (column) => ({
      programLabel: column?.programLabel || 'Programma TOP',
      stepLabel: column?.label || 'Step',
      available: false,
      done: false,
      doneAt: null,
      plannedAt: null,
      adminApproved: false,
      dailyState: '',
      status: 'blank',
      label: '',
      meta: '',
      title: '',
    });

    const isTrackingCellVisible = (cell) =>
      !!cell && cell.status !== 'blank' && cell.status !== 'not_applicable';

    const resolveTrackingCell = (user, column) => {
      const tracking = resolveTopTracking(user);
      const cell = tracking?.programs?.[column?.programIndex]?.steps?.[column?.stepSlot] || null;
      if (cell) return cell;

      const totalPrograms = Number(tracking?.totalPrograms) || 0;
      if (totalPrograms > 0 && Number(column?.programIndex) > totalPrograms) {
        return buildUnavailableTrackingCell(column);
      }

      return null;
    };

    const hasVisibleTrackingState = (user, column) => isTrackingCellVisible(resolveTrackingCell(user, column));

    const stepTrackingLabel = (user, column) => {
      const cell = resolveTrackingCell(user, column);
      return isTrackingCellVisible(cell) ? cell.label || '' : '';
    };

    const stepTrackingMeta = (user, column) => {
      const cell = resolveTrackingCell(user, column);
      if (!isTrackingCellVisible(cell)) return '';
      if (cell.status === 'complete') {
        return cell.doneAt ? formatDate(cell.doneAt) : '';
      }
      if (cell.status === 'overdue' || cell.status === 'on_track') {
        return formatCompactDayDiffLabel(getDayDiffFromToday(cell.plannedAt));
      }
      if (cell.status === 'today') {
        return 'oggi';
      }
      return '';
    };

    const stepTrackingTitle = (user, column) =>
      resolveTrackingCell(user, column)?.title || '';

    const stepTrackingClass = (user, column) => {
      const status = resolveTrackingCell(user, column)?.status || 'not_applicable';
      if (status === 'blank' || status === 'not_applicable') return '';
      if (status === 'complete') return 'step-status-pill--done';
      if (status === 'overdue') return 'step-status-pill--danger';
      if (status === 'today') return 'step-status-pill--warning';
      if (status === 'on_track') return 'step-status-pill--info';
      if (status === 'todo') return 'step-status-pill--neutral';
      if (status === 'waiting') return 'step-status-pill--waiting';
      if (status === 'blocked') return 'step-status-pill--blocked';
      if (status === 'not_applicable') return 'step-status-pill--na';
      return 'step-status-pill--empty';
    };

    const stepTrackingShowsApprovedIcon = (user, column) => {
      if (column?.stepSlot !== 'questionario') return false;
      const cell = resolveTrackingCell(user, column);
      if (!cell?.available) return false;
      return cell.adminApproved && cell.dailyState === 'inviato';
    };

    const needsTopRenewal = (user) => {
      if (isTopHistoryUser(user)) return false;
      const tracking = resolveTopTracking(user);
      if (tracking?.activeServiceTier && tracking.activeServiceTier !== 'top') {
        return false;
      }
      if (tracking?.hasPendingTopRenewal || tracking?.hasPendingDowngrade) {
        return false;
      }
      const totalPrograms = Number(tracking?.totalPrograms) || 0;
      if (totalPrograms <= 0) return false;
      const lastProgram = tracking?.programs?.[totalPrograms];
      if (!lastProgram?.exists) return false;
      return !!lastProgram?.steps?.consegna?.done;
    };

    const resolveTopProgramCount = (user) => {
      const fromOrder = Number(user?._topOrderProgramCount);
      const fromTracking = Number(user?._topTracking?.totalPrograms);
      return Math.max(
        Number.isFinite(fromOrder) ? fromOrder : 0,
        Number.isFinite(fromTracking) ? fromTracking : 0
      );
    };

    const loadTopTracking = async (userList, signal) => {
      if (!userList.length || signal.aborted) return;
      const readDocs = (queryRef) => readTopSnapshot(queryRef, { signal });
      const targetIds = new Set(userList.map((user) => user.uid));
      users.value = users.value.map((user) => targetIds.has(user.uid)
        ? { ...user, _topTrackingLoading: true, _topTrackingError: false }
        : user);
      isTrackingLoading.value = true;
      trackingError.value = '';
      const updateProgress = () => {
        trackingLoadedUsers.value = users.value.filter((user) => !user._topTrackingLoading && !user._topTrackingError).length;
      };
      updateProgress();
      try {
        await loadLatestChecksForUsers(userList, {
          signal,
          readDocs,
          async onChunkLoaded(chunk, { latestByUid, diagnosticByUid, trackingByUid }) {
            if (signal.aborted) return;
            const chunkIds = new Set(chunk);
            users.value = users.value.map((user) => {
              if (!chunkIds.has(user.uid)) return user;
              const latestCheck = latestByUid.get(user.uid) || null;
              const checkDiagnostic =
                diagnosticByUid.get(user.uid) || createEmptyCheckDiagnostic();
              return {
                ...user,
                _latestCheckKey: latestCheck?.key || '',
                _latestCheckDoneAt: latestCheck?.doneAt || null,
                _latestCheckDoneMs: latestCheck?.doneAtMs || 0,
                _latestCheckPercorsoId: latestCheck?.percorsoId || null,
                _latestCheckStepIndex: Number.isInteger(latestCheck?.stepIndex)
                  ? latestCheck.stepIndex
                  : null,
                _latestCheckProgramTitle: latestCheck?.programTitle || null,
                _checkDiagnostic: checkDiagnostic,
                _topTracking: trackingByUid.get(user.uid) || buildEmptyTopTracking(),
                _topTrackingLoading: false,
                _topTrackingError: false,
              };
            });
            updateProgress();
            await nextTick();
          },
          onChunkFailed(chunk, error) {
            console.warn('Impossibile caricare un gruppo di percorsi TOP:', error);
            const failedIds = new Set(chunk);
            users.value = users.value.map((user) => failedIds.has(user.uid)
              ? { ...user, _topTrackingLoading: false, _topTrackingError: true }
              : user);
          },
        });
      } finally {
        if (!signal.aborted) {
          isTrackingLoading.value = false;
          updateProgress();
          const failedCount = users.value.filter((user) => user._topTrackingError).length;
          trackingError.value = failedCount ? `Percorsi non caricati per ${failedCount} utenti. Riprova.` : '';
        }
      }
    };

    const retryTopTracking = () => {
      if (isTrackingLoading.value || !loadController || loadController.signal.aborted) return;
      return loadTopTracking(users.value.filter((user) => user._topTrackingError), loadController.signal);
    };

    const fetchTopUsers = async () => {
      loadController?.abort();
      loadController = new AbortController();
      const { signal } = loadController;
      const readDocs = (queryRef) => readTopSnapshot(queryRef, { signal });
      loadError.value = '';
      trackingError.value = '';
      loadingMessage.value = 'Caricamento degli ordini TOP…';
      isLoading.value = true;
      isTrackingLoading.value = false;
      trackingLoadedUsers.value = 0;

      try {
        const usersMap = new Map();
        const topOrderMetaByUid = new Map();
        const topOrderMetaByEmail = new Map();

        const updateOrderMeta = (map, key, info) => {
          if (!key || !info) return;
          const current = map.get(key);
          if (!current || info.orderTime > current.orderTime) {
            map.set(key, info);
            return;
          }
          if (
            info.orderTime === current.orderTime &&
            (
              info.programCount > current.programCount ||
              info.durationMonths > current.durationMonths
            )
          ) {
            map.set(key, info);
          }
        };

        let productIndex = null;

        const registerTopOrder = (order) => {
          if (!isPaidOrder(order)) return;
          const fallbackTime = resolveOrderTimeMs(order);
          let orderTime = fallbackTime;
          if (Number.isFinite(order?.topSkuOrderAt) && order.topSkuOrderAt > 0) {
            orderTime = order.topSkuOrderAt;
          } else if (typeof order?.topSkuOrderAt?.toDate === 'function') {
            const ts = order.topSkuOrderAt.toDate();
            if (ts instanceof Date && !Number.isNaN(ts.getTime())) {
              orderTime = ts.getTime();
            }
          }

          let durationMonths = 0;
          let programCount = 0;
          const products = Array.isArray(order.products) ? order.products : [];
          const lineItems = Array.isArray(order.line_items) ? order.line_items : [];
          const allLines = [...products, ...lineItems];
          allLines.forEach((line) => {
            if (!lineMatchesTopSku(line)) return;
            const lineDuration = resolveLineDurationMonths(line, productIndex);
            if (lineDuration > durationMonths) durationMonths = lineDuration;
            const lineProgramCount = resolveLineProgramCount(line, productIndex);
            if (lineProgramCount > programCount) programCount = lineProgramCount;
          });

          const expiryDate = durationMonths > 0 && orderTime > 0
            ? addMonths(new Date(orderTime), durationMonths)
            : null;
          const expiryMs = expiryDate ? expiryDate.getTime() : 0;

          const metaInfo = {
            orderTime,
            programCount,
            durationMonths,
            expiryMs,
          };

          const emailCandidates = [
            order.userEmail,
            order.customerEmail,
            order.email,
            order.customer_email,
            order.billing?.email,
          ];
          emailCandidates.forEach((email) => {
            const normalized = normalizeEmail(email);
            if (normalized) {
              updateOrderMeta(topOrderMetaByEmail, normalized, metaInfo);
            }
          });

          const uidCandidates = [order.userUid, order.uid, order.userId];
          uidCandidates.forEach((uid) => {
            const trimmed = String(uid || '').trim();
            if (trimmed) {
              updateOrderMeta(topOrderMetaByUid, trimmed, metaInfo);
            }
          });
        };

        const ordersRef = collection(db, 'orders');
        const loadTopOrders = async () => {
          const records = [];
          let lastDoc = null;
          let hasMore = true;

          while (hasMore) {
            const q = lastDoc
              ? query(
                  ordersRef,
                  where('topSkuHit', '==', true),
                  orderBy('topSkuOrderAt', 'desc'),
                  startAfter(lastDoc),
                  limit(TOP_ORDER_PAGE_SIZE)
                )
              : query(
                  ordersRef,
                  where('topSkuHit', '==', true),
                  orderBy('topSkuOrderAt', 'desc'),
                  limit(TOP_ORDER_PAGE_SIZE)
                );
            const snap = await readDocs(q);
            if (snap.empty) break;

            snap.forEach((docSnap) => {
              records.push({ id: docSnap.id, ...docSnap.data() });
            });

            lastDoc = snap.docs[snap.docs.length - 1];
            hasMore = snap.size === TOP_ORDER_PAGE_SIZE;
            await nextTick();
          }
          return records;
        };

        const [resolvedProductIndex, topOrders] = await Promise.all([
          buildProductsIndex(db, readDocs).catch((err) => {
            if (signal.aborted) throw err;
            console.warn('Impossibile caricare products per durata:', err);
            return null;
          }),
          loadTopOrders(),
        ]);
        if (signal.aborted) return;
        loadingMessage.value = 'Caricamento dei profili TOP…';
        productIndex = resolvedProductIndex;
        topOrders.forEach(registerTopOrder);

        const uids = Array.from(topOrderMetaByUid.keys());
        const emails = Array.from(topOrderMetaByEmail.keys());

        const [uidSnapshots, emailSnapshots] = await Promise.all([
          mapWithConcurrency(
            chunkList(uids, TOP_UID_BATCH_SIZE),
            TOP_LIST_QUERY_CONCURRENCY,
            (chunk) => readDocs(
              query(collection(db, 'users'), where(documentId(), 'in', chunk))
            )
          ),
          mapWithConcurrency(
            chunkList(emails, TOP_CHUNK_SIZE),
            TOP_LIST_QUERY_CONCURRENCY,
            (chunk) => readDocs(
              query(collection(db, 'users'), where('email', 'in', chunk))
            )
          ),
        ]);

        if (signal.aborted) return;
        [...uidSnapshots, ...emailSnapshots].forEach((snap) => {
          snap.forEach((docSnap) => {
            if (!usersMap.has(docSnap.id)) {
              usersMap.set(docSnap.id, { uid: docSnap.id, ...docSnap.data() });
            }
          });
        });

        const resolveUserTopOrderInfo = (user) => {
          const uidKey = user?.uid || '';
          const emailKey = normalizeEmail(user?.email);
          const uidInfo = uidKey ? topOrderMetaByUid.get(uidKey) : null;
          const emailInfo = emailKey ? topOrderMetaByEmail.get(emailKey) : null;
          if (!uidInfo) {
            return emailInfo || {
              orderTime: 0,
              programCount: 0,
              durationMonths: 0,
              expiryMs: 0,
            };
          }
          if (!emailInfo) return uidInfo;
          return uidInfo.orderTime >= emailInfo.orderTime ? uidInfo : emailInfo;
        };

        const list = Array.from(usersMap.values())
          .map((user) => {
            const info = resolveUserTopOrderInfo(user);
            return {
              ...user,
              [CONTACT_SAVED_FIELD]: Boolean(user?.[CONTACT_SAVED_FIELD]),
              [TOP_LIST_NOTE_FIELD]: String(user?.[TOP_LIST_NOTE_FIELD] || ''),
              _topOrderTime: info.orderTime || 0,
              _topOrderProgramCount: info.programCount || info.durationMonths || 0,
              _topOrderDurationMonths: info.durationMonths || 0,
              _topOrderExpiryMs: info.expiryMs || 0,
            };
          })
          .sort((a, b) => {
            const orderDiff = (b._topOrderTime || 0) - (a._topOrderTime || 0);
            if (orderDiff !== 0) return orderDiff;
            return resolveUserCreatedTime(b) - resolveUserCreatedTime(a);
          });

        users.value = list.map((user) => {
          return {
            ...user,
            _latestCheckKey: '',
            _latestCheckDoneAt: null,
            _latestCheckDoneMs: 0,
            _latestCheckPercorsoId: null,
            _latestCheckStepIndex: null,
            _latestCheckProgramTitle: null,
            _checkDiagnostic: createEmptyCheckDiagnostic(),
            _topTracking: buildEmptyTopTracking(),
            _topTrackingLoading: true,
            _topTrackingError: false,
          };
        });
        isLoading.value = false;
        isTrackingLoading.value = list.length > 0;
        await nextTick();

        loadTicketStatuses(list, readDocs, signal).catch((error) => {
          if (!signal.aborted) console.warn('Impossibile caricare gli stati ticket TOP:', error);
        });

        await loadTopTracking(list, signal);
      } catch (error) {
        if (signal.aborted) return;
        console.error('Errore nel caricamento degli utenti TOP:', error);
        loadError.value = error?.code === 'permission-denied'
          ? 'Non hai accesso alla lista TOP con questo account.'
          : 'Non riesco a caricare gli utenti TOP. Riprova tra poco.';
        isLoading.value = false;
        loadController.abort();
        users.value = [];
        isTrackingLoading.value = false;
      } finally {
        if (!signal.aborted) isLoading.value = false;
      }
    };

    onMounted(fetchTopUsers);

    const activeTopUsers = computed(() =>
      users.value.filter((user) => !isTopHistoryUser(user))
    );
    const topHistoryUsers = computed(() =>
      users.value.filter((user) => isTopHistoryUser(user))
    );
    const currentTopViewUsers = computed(() =>
      topListView.value === 'history' ? topHistoryUsers.value : activeTopUsers.value
    );

    const filteredUsers = computed(() => {
      let list = currentTopViewUsers.value.slice();

      if (showUnsavedOnly.value) {
        list = list.filter((user) => !user?.[CONTACT_SAVED_FIELD]);
      }

      if (showRenewalOnly.value) {
        list = list.filter((user) => needsTopRenewal(user));
      }

      list = list.filter((user) =>
        matchesSearch(user) && matchesCheckFilter(user) && matchesProgressFilter(user)
      );

      if (!showExpiringOnly.value) {
        return sortTopUsers(list);
      }
      const now = Date.now();
      const days = Number(expiringWindowDays.value) || 30;
      const windowMs = days * 24 * 60 * 60 * 1000;
      list = list.filter((user) =>
        user._topOrderExpiryMs &&
        user._topOrderExpiryMs >= now &&
        user._topOrderExpiryMs <= now + windowMs
      );

      return sortTopUsers(list);
    });

    const totalPages = computed(() =>
      Math.max(1, Math.ceil(filteredUsers.value.length / pageSize.value))
    );
    const paginatedUsers = computed(() => {
      const normalizedPage = Math.min(Math.max(currentPage.value, 1), totalPages.value);
      const start = (normalizedPage - 1) * pageSize.value;
      return filteredUsers.value.slice(start, start + pageSize.value);
    });
    const paginationStart = computed(() => {
      if (!filteredUsers.value.length) return 0;
      return (currentPage.value - 1) * pageSize.value + 1;
    });
    const paginationEnd = computed(() =>
      Math.min(currentPage.value * pageSize.value, filteredUsers.value.length)
    );
    const goToPage = (page) => {
      const nextPage = Math.min(Math.max(Number(page) || 1, 1), totalPages.value);
      currentPage.value = nextPage;
    };

    watch(totalPages, (nextTotal) => {
      if (currentPage.value > nextTotal) {
        currentPage.value = nextTotal;
      }
    });
    watch(
      [
        topListView,
        searchQuery,
        checkFilter,
        progressFilter,
        showExpiringOnly,
        showUnsavedOnly,
        showRenewalOnly,
        expiringWindowDays,
        pageSize,
      ],
      () => {
        currentPage.value = 1;
      }
    );

    const visibleTrackingProgramCount = computed(() => {
      const source = filteredUsers.value.length
        ? filteredUsers.value
        : currentTopViewUsers.value;
      return source.reduce((max, user) => Math.max(max, resolveTopProgramCount(user)), 0);
    });

    const trackingPrograms = computed(() => buildTrackingPrograms(visibleTrackingProgramCount.value));
    const trackingColumns = computed(() => buildTrackingColumns(trackingPrograms.value));
    const emptyStateColspan = computed(() => buildEmptyStateColspan(trackingColumns.value));
    const topTableMinWidth = computed(() => {
      const fixedColumnsWidth = 92 + 320 + 168 + 136 + 240 + 152;
      const stepColumnsWidth = trackingColumns.value.length * TRACKING_STEP_COLUMN_WIDTH;
      const groupGapsWidth = Math.max(0, trackingPrograms.value.length - 1) * TRACKING_GROUP_GAP;
      return Math.max(1880, fixedColumnsWidth + stepColumnsWidth + groupGapsWidth);
    });

    const renewalUsersCount = computed(() =>
      activeTopUsers.value.filter((user) => needsTopRenewal(user)).length
    );

    const usersWithCheckCount = computed(() =>
      currentTopViewUsers.value.filter((user) => !!user?._latestCheckKey).length
    );

    const activeTopUsersCount = computed(() => activeTopUsers.value.length);
    const topHistoryUsersCount = computed(() => topHistoryUsers.value.length);

    const hasActiveFilters = computed(() =>
      Boolean(
        String(searchQuery.value || '').trim() ||
        checkFilter.value !== 'all' ||
        progressFilter.value !== 'all' ||
        showExpiringOnly.value ||
        showUnsavedOnly.value ||
        showRenewalOnly.value ||
        Number(expiringWindowDays.value) !== 30
      )
    );

    const hasTopOrderDetails = (user) =>
      Boolean(
        user?._topOrderTime ||
        user?._topOrderProgramCount ||
        user?._topOrderDurationMonths ||
        user?._topOrderExpiryMs
      );

    const formatTopOrderDuration = (value) => {
      const months = Number(value);
      if (!Number.isFinite(months) || months <= 0) return '—';
      return months === 1 ? '1 mese' : `${months} mesi`;
    };

    const formatTopOrderProgramCount = (value) => {
      const count = Number(value);
      if (!Number.isFinite(count) || count <= 0) return '—';
      return count === 1 ? '1 programma' : `${count} programmi`;
    };

    const topOrderTooltipLabel = (user) => {
      const orderDate = user?._topOrderTime ? formatDate(user._topOrderTime) : '—';
      const programCount = formatTopOrderProgramCount(user?._topOrderProgramCount);
      const duration = formatTopOrderDuration(user?._topOrderDurationMonths);
      const expiry = user?._topOrderExpiryMs ? formatDate(user._topOrderExpiryMs) : '—';
      const tracking = user?._topTracking || {};
      const cycles = Number(tracking.cycleCount) || 0;
      const completed = Number(tracking.completedCycleCount) || 0;
      const previousCompleted = Number(tracking.completedPreviousCycleCount) || 0;
      const active = Number(tracking.activeCycleNumber) || 0;
      const currentCompleted = tracking.currentCycleCompleted ? 'sì' : 'no';
      const renewal = tracking.hasRenewed ? 'sì' : 'no';
      return `Data ordine TOP ${orderDate}, ${programCount}, durata ${duration}, scadenza ${expiry}, cicli ${cycles}, ciclo attivo ${active || '—'}, ciclo corrente terminato ${currentCompleted}, cicli precedenti terminati ${previousCompleted}, terminati totali ${completed}, rinnovato ${renewal}`;
    };

    const hasTopCycleDetails = (user) => {
      const tracking = user?._topTracking || {};
      return (
        Number(tracking.cycleCount) > 1 ||
        Boolean(tracking.currentCycleCompleted) ||
        Boolean(tracking.hasRenewed)
      );
    };

    const topCycleLabel = (user) => {
      const tracking = user?._topTracking || {};
      const cycleCount = Number(tracking.cycleCount) || 0;
      const activeCycleNumber = Number(tracking.activeCycleNumber) || 0;
      if (cycleCount <= 1 || activeCycleNumber <= 0) return '';
      return `Ciclo ${activeCycleNumber}`;
    };

    const topCompletedCycleLabel = (user) => {
      return user?._topTracking?.currentCycleCompleted ? 'Terminato' : '';
    };

    const hasTopRenewed = (user) => Boolean(user?._topTracking?.hasRenewed);

    const topLifecycleStatusLabel = (user) => {
      const visibilityOverride = resolveUserVisibilityOverride(user);
      if (visibilityOverride === TOP_LIST_VISIBILITY_ARCHIVE) {
        return 'Storico manuale';
      }
      if (visibilityOverride === TOP_LIST_VISIBILITY_ACTIVE) {
        return 'Attiva forzata';
      }
      const tracking = user?._topTracking || {};
      const activeTierLabel = String(tracking.activeServiceTier || '').toUpperCase();
      const nextTierLabel = String(tracking.nextServiceTier || '').toUpperCase();
      if (tracking.automaticTopHistory) {
        return activeTierLabel ? `Passata a ${activeTierLabel}` : 'Downgrade attivo';
      }
      if (tracking.hasPendingDowngrade) {
        return nextTierLabel ? `Passaggio a ${nextTierLabel}` : 'Downgrade acquistato';
      }
      if (tracking.hasPendingTopRenewal) return 'Rinnovo acquistato';
      return '';
    };

    const topLifecycleStatusClass = (user) => {
      const visibilityOverride = resolveUserVisibilityOverride(user);
      if (visibilityOverride === TOP_LIST_VISIBILITY_ARCHIVE) {
        return 'top-order-mini-chip--archive';
      }
      if (visibilityOverride === TOP_LIST_VISIBILITY_ACTIVE) {
        return 'top-order-mini-chip--forced';
      }
      if (user?._topTracking?.automaticTopHistory) {
        return 'top-order-mini-chip--archive';
      }
      if (user?._topTracking?.hasPendingDowngrade) {
        return 'top-order-mini-chip--transition';
      }
      return 'top-order-mini-chip--renewed';
    };

    const topLifecycleStatusTitle = (user) => {
      const label = topLifecycleStatusLabel(user);
      const reason = String(
        user?.[TOP_LIST_VISIBILITY_OVERRIDE_REASON_FIELD] || ''
      ).trim();
      const changedAt = user?.[TOP_LIST_VISIBILITY_OVERRIDE_AT_FIELD];
      const details = [label];
      if (reason) details.push(reason);
      if (changedAt) details.push(formatDateTime(changedAt));
      return details.filter(Boolean).join(' • ');
    };

    const formatUserFullName = (user) => {
      const fullName = [user?.name, user?.surname].filter(Boolean).join(' ').trim();
      return fullName || user?.email || '—';
    };

    const hasUserIdentityDetails = (user) =>
      Boolean(String(user?.email || '').trim() || String(user?._latestCheckProgramTitle || '').trim());

    const userIdentityTooltipLabel = (user) => {
      const parts = [String(user?.email || '').trim(), String(user?._latestCheckProgramTitle || '').trim()]
        .filter(Boolean);
      return parts.join('. ');
    };

    const checkDiagnosticTitle = (user) => {
      const diagnostic = user?._checkDiagnostic || createEmptyCheckDiagnostic();
      if (!diagnostic.percorsiCount) return 'Nessun percorso collegato';
      if (!diagnostic.checkStepsFound) return 'Check finale non trovato';
      if (diagnostic.incompleteCheckSteps > 0) return 'Check finale non completato';
      if (diagnostic.invalidDoneAtCheckSteps > 0) return 'Check senza data valida';
      if (diagnostic.convertedCheckSteps > 0) return 'Solo check convertiti';
      return 'Check non disponibile';
    };

    const checkDiagnosticLines = (user) => {
      const diagnostic = user?._checkDiagnostic || createEmptyCheckDiagnostic();
      const lines = [];

      if (!diagnostic.percorsiCount) {
        lines.push('Nessun documento trovato in percorsi con uid/userUid di questo utente.');
        return lines;
      }

      lines.push(`Percorsi trovati: ${diagnostic.percorsiCount}`);
      if (diagnostic.percorsiWithoutSteps > 0) {
        lines.push(`Percorsi senza steps: ${diagnostic.percorsiWithoutSteps}`);
      }

      if (!diagnostic.checkStepsFound) {
        lines.push('Nessuno step con nome contenente check o scadenza.');
        return lines;
      }

      lines.push(`Step check/scadenza trovati: ${diagnostic.checkStepsFound}`);
      if (diagnostic.incompleteCheckSteps > 0) {
        lines.push(`Step non completati: ${diagnostic.incompleteCheckSteps}`);
      }
      if (diagnostic.invalidDoneAtCheckSteps > 0) {
        lines.push(`Step senza doneAt valido: ${diagnostic.invalidDoneAtCheckSteps}`);
      }
      if (diagnostic.convertedCheckSteps > 0) {
        lines.push(`Step convertiti da questionario: ${diagnostic.convertedCheckSteps}`);
      }

      return lines;
    };

    const checkDiagnosticAriaLabel = (user) => {
      const title = checkDiagnosticTitle(user);
      const lines = checkDiagnosticLines(user);
      return [title, ...lines].join('. ');
    };

    return {
      topControlHelp: TOP_CONTROL_HELP,
      users,
      filteredUsers,
      paginatedUsers,
      isLoading,
      isTrackingLoading,
      trackingLoadedUsers,
      loadingMessage,
      loadError,
      trackingError,
      fetchTopUsers,
      retryTopTracking,
      currentPage,
      pageSize,
      pageSizeOptions: TOP_LIST_PAGE_SIZE_OPTIONS,
      totalPages,
      paginationStart,
      paginationEnd,
      goToPage,
      filtersOpen,
      viewUserDetails,
      viewUserCommunications,
      viewTechnicalConversation,
      showCreateConversationModal,
      newConversation,
      isCreatingConversation,
      createConversation,
      closeCreateConversationModal,
      openDeliveryMessagesModal,
      closeDeliveryMessagesModal,
      showDeliveryMessagesModal,
      deliveryMessages,
      showFullMessage,
      copyMessageToConversation,
      truncateMessage,
      toggleFullMessage,
      formatDate,
      canAccessBackfill,
      goToBackfill,
      showExpiringOnly,
      showUnsavedOnly,
      showRenewalOnly,
      topListView,
      setTopListView,
      toggleExpiringOnly,
      toggleUnsavedOnly,
      toggleRenewalOnly,
      handleCheckFilterChange,
      expiringWindowDays,
      searchQuery,
      checkFilter,
      progressFilter,
      hasActiveFilters,
      resetQuickFilters,
      savingContactFlags,
      savingNoteFlags,
      savingVisibilityFlags,
      toggleContactSaved,
      queueTopListNoteSave,
      needsTopRenewal,
      checkDateTitle,
      relativeCheckLabel,
      renewalUsersCount,
      activeTopUsersCount,
      topHistoryUsersCount,
      currentTopViewUsers,
      usersWithCheckCount,
      hasTopOrderDetails,
      formatTopOrderProgramCount,
      formatTopOrderDuration,
      topOrderTooltipLabel,
      hasTopCycleDetails,
      topCycleLabel,
      topCompletedCycleLabel,
      hasTopRenewed,
      topLifecycleStatusLabel,
      topLifecycleStatusClass,
      topLifecycleStatusTitle,
      isTopHistoryUser,
      hasTopVisibilityOverride,
      moveUserToTopHistory,
      restoreUserToActiveTop,
      resetTopVisibilityOverride,
      TOP_LIST_NOTE_FIELD,
      formatUserFullName,
      hasUserIdentityDetails,
      userIdentityTooltipLabel,
      trackingPrograms,
      trackingColumns,
      emptyStateColspan,
      topTableMinWidth,
      hasVisibleTrackingState,
      stepTrackingLabel,
      stepTrackingMeta,
      stepTrackingTitle,
      stepTrackingClass,
      stepTrackingShowsApprovedIcon,
      checkDiagnosticTitle,
      checkDiagnosticLines,
      checkDiagnosticAriaLabel,
    };
  },
};
</script>

<style scoped>
.card-surface {
  background: #ffffff;
  border-radius: 22px;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.08);
  padding: 18px 20px;
  margin-top: 22px;
}

.toolbar-card {
  margin-top: 24px;
}

.filters-header {
  display: flex;
  align-items: center;
}

.accordion-toggle {
  flex: 1 1 auto;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  color: #0f172a;
  cursor: pointer;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.accordion-toggle:hover {
  background: #ffffff;
  border-color: #cbd5e1;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.08);
}

.accordion-toggle .material-icons {
  font-size: 22px;
  color: #475569;
}

.toggle-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toggle-title {
  font-size: 0.96rem;
  font-weight: 700;
}

.toggle-subtitle {
  font-size: 0.82rem;
  color: #64748b;
}

.accordion-panel {
  margin-top: 14px;
  padding: 16px 14px;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.18s ease;
}

.accordion-enter-from,
.accordion-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.filters-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: flex-end;
}

.filter-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.filter-field--wide {
  grid-column: span 1;
}

.filter-field--compact {
  max-width: 220px;
}

.filters-secondary {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 14px;
  margin-top: 14px;
}

.filter-field label {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.summary-pills {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.summary-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: rgba(255, 255, 255, 0.9);
  color: #334155;
  font-size: 0.8rem;
  font-weight: 700;
  white-space: nowrap;
}

.summary-pill--clickable {
  cursor: pointer;
  appearance: none;
  font-family: inherit;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.summary-pill--clickable:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.1);
}

.summary-pill--active {
  transform: translateY(-1px);
  border-color: rgba(37, 99, 235, 0.55);
  background: #dbeafe;
  color: #1e3a8a;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.16), 0 12px 24px rgba(37, 99, 235, 0.16);
}

.summary-pill--danger.summary-pill--active {
  border-color: rgba(239, 68, 68, 0.58);
  background: #fee2e2;
  color: #991b1b;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.16), 0 12px 24px rgba(239, 68, 68, 0.14);
}

.summary-pill--archive {
  border-color: rgba(100, 116, 139, 0.28);
  background: #f8fafc;
  color: #475569;
}

.summary-pill--archive.summary-pill--active {
  border-color: rgba(100, 116, 139, 0.58);
  background: #e2e8f0;
  color: #1e293b;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.16), 0 12px 24px rgba(71, 85, 105, 0.14);
}

.summary-pill--danger {
  border-color: rgba(239, 68, 68, 0.28);
  background: #fef2f2;
  color: #b91c1c;
}

.search-bar {
  width: 100%;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: #ffffff;
  padding: 10px 14px;
  font-size: 0.95rem;
  color: #0f172a;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-bar:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.65);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  flex: 1 1 0;
  margin-top: 0;
}

.filter-action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 16px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #ffffff;
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.filter-action-button:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: rgba(99, 102, 241, 0.42);
  background: #eef2ff;
  color: #4338ca;
  box-shadow: 0 14px 30px rgba(99, 102, 241, 0.16);
}

.filter-action-button .material-icons {
  font-size: 20px;
}

.filter-action-button--active {
  border-color: transparent;
  background: linear-gradient(120deg, #2563eb, #4338ca);
  color: #ffffff;
  box-shadow: 0 14px 30px rgba(37, 99, 235, 0.24);
}

.filter-action-button--active:hover:not(:disabled) {
  background: linear-gradient(120deg, #2563eb, #4338ca);
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 18px 34px rgba(37, 99, 235, 0.3);
}

.filter-action-button--accent {
  border-color: transparent;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(34, 197, 94, 0.3);
}

.filter-action-button--accent:hover:not(:disabled) {
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.35);
}

.filter-action-button--neutral {
  border-color: transparent;
  background: linear-gradient(120deg, #0f172a, #334155);
  color: #ffffff;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.18);
}

.filter-action-button--neutral:hover:not(:disabled) {
  background: linear-gradient(120deg, #0f172a, #334155);
  color: #ffffff;
  border-color: transparent;
  box-shadow: 0 18px 34px rgba(15, 23, 42, 0.22);
}

.filter-action-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.filters-summary {
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid rgba(226, 232, 240, 0.95);
}

.filters-summary-heading {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 18px;
  margin-bottom: 10px;
}

.filters-summary-label {
  display: inline-block;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #64748b;
}

.filters-summary-stats {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 14px;
  font-size: 0.78rem;
  color: #64748b;
}

.filters-summary-stats span {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  white-space: nowrap;
}

.filters-summary-stats strong {
  color: #334155;
  font-weight: 800;
}

.top-monitor-shell {
  margin-top: 22px;
  padding: 18px;
}

.top-monitor-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 16px;
}

.top-monitor-copy {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.top-monitor-eyebrow {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #64748b;
}

.top-monitor-title {
  margin: 0;
  font-size: 1.35rem;
  line-height: 1.1;
  color: #0f172a;
}

.top-monitor-subtitle {
  margin: 0;
  max-width: 640px;
  font-size: 0.9rem;
  color: #64748b;
}

.tracking-loading-status {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  flex: 0 0 auto;
  padding: 9px 13px;
  border: 1px solid rgba(59, 130, 246, 0.22);
  border-radius: 999px;
  background: rgba(239, 246, 255, 0.92);
  color: #1d4ed8;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
}

.tracking-loading-status__spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(59, 130, 246, 0.24);
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: top-tracking-spin 0.75s linear infinite;
}

@keyframes top-tracking-spin {
  to {
    transform: rotate(360deg);
  }
}

.top-list-pagination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 12px;
  color: #475569;
  font-size: 0.8rem;
  font-weight: 700;
}

.top-list-pagination--bottom {
  margin-top: 14px;
  margin-bottom: 0;
}

.top-list-pagination__summary {
  margin-right: auto;
}

.top-list-pagination__size,
.top-list-pagination__buttons {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.top-list-pagination__size select {
  min-width: 70px;
  padding: 7px 28px 7px 10px;
  border: 1px solid rgba(148, 163, 184, 0.42);
  border-radius: 10px;
  background: #ffffff;
  color: #334155;
  font: inherit;
}

.top-list-pagination__buttons button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid rgba(148, 163, 184, 0.36);
  border-radius: 10px;
  background: #ffffff;
  color: #334155;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease;
}

.top-list-pagination__buttons button:hover:not(:disabled) {
  border-color: rgba(37, 99, 235, 0.45);
  background: #eff6ff;
  color: #1d4ed8;
}

.top-list-pagination__buttons button:disabled {
  opacity: 0.42;
  cursor: not-allowed;
}

.top-list-pagination__buttons .material-icons {
  font-size: 20px;
}

.tickets {
  overflow-x: auto;
  overflow-y: visible;
}

.top-monitor-scroll {
  padding-bottom: 6px;
  border-radius: 22px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: rgba(255, 255, 255, 0.75);
}

.users-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.95rem;
  color: #0f172a;
  box-shadow: none;
  border-radius: 22px;
  table-layout: fixed;
  background: linear-gradient(180deg, #fbfcff 0%, #f8fafc 100%);
}

.users-table thead th {
  background: linear-gradient(180deg, #f7f9fc 0%, #eef2f7 100%);
  padding: 14px 16px;
  font-weight: 800;
  font-size: 0.72rem;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: #475569;
  border-bottom: 1px solid #dbe2f0;
  white-space: nowrap;
  text-align: center;
}

.users-table thead tr:first-child th {
  position: sticky;
  top: 0;
  z-index: 6;
  box-shadow: inset 0 -1px 0 rgba(226, 232, 240, 0.9);
}

.users-table thead tr:nth-child(2) th {
  position: sticky;
  top: 46px;
  z-index: 5;
  padding-top: 11px;
  padding-bottom: 11px;
  font-size: 0.63rem;
}

.users-table .actions-column,
.users-table tbody td:last-child {
  width: 152px;
  text-align: center;
}

.users-table .saved-column {
  width: 92px;
  text-align: center;
}

.users-table .user-column {
  width: 320px;
}

.users-table .top-order-column {
  width: 168px;
  text-align: center;
}

.program-group-column {
  background: linear-gradient(180deg, #eef4ff 0%, #e3ecfb 100%) !important;
  color: #1e3a8a !important;
  box-shadow: inset 0 -1px 0 rgba(148, 163, 184, 0.22);
}

.program-group-column--tone-1 {
  background: linear-gradient(180deg, #edf4ff 0%, #dbeafe 100%) !important;
}

.program-group-column--tone-2 {
  background: linear-gradient(180deg, #fff7e6 0%, #fef3c7 100%) !important;
  color: #92400e !important;
}

.program-group-column--tone-3 {
  background: linear-gradient(180deg, #ebfbf1 0%, #dcfce7 100%) !important;
  color: #166534 !important;
}

.program-group-column--tone-4 {
  background: linear-gradient(180deg, #f5f3ff 0%, #ede9fe 100%) !important;
  color: #6d28d9 !important;
}

.program-group-column--group-gap {
  border-left: 18px solid rgba(248, 250, 252, 0.98);
  background-clip: padding-box !important;
}

.users-table .check-column {
  width: 136px;
  text-align: center;
}

.users-table .note-column,
.users-table .note-cell {
  width: 240px;
  min-width: 240px;
  max-width: 240px;
}

.users-table tbody tr {
  --row-bg: #ffffff;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
}

.users-table tbody tr:nth-child(even) {
  --row-bg: #fcfdff;
}

.users-table tbody tr:hover {
  --row-bg: #f3f7ff;
}

.users-table tbody tr.users-row--top-renewal {
  --row-bg: #fef2f2;
}

.users-table tbody tr.users-row--top-renewal:hover {
  --row-bg: #fee2e2;
}

.users-table tbody tr.users-row--top-renewal > td {
  background: var(--row-bg) !important;
}

.users-table tbody tr.users-row--top-history {
  --row-bg: #f8fafc;
}

.users-table tbody tr.users-row--top-history:hover {
  --row-bg: #eef2f7;
}

.users-table tbody td {
  padding: 12px 10px;
  border-bottom: 1px solid #e4e9f2;
  vertical-align: middle;
  color: #0f172a;
  background: var(--row-bg);
  white-space: normal;
  word-break: break-word;
}

.step-status-column,
.step-status-cell {
  width: 132px;
  min-width: 132px;
  max-width: 132px;
  box-sizing: border-box;
  text-align: center;
}

.step-status-column--tone-1,
.step-status-cell--tone-1 {
  background: rgba(219, 234, 254, 0.16);
}

.step-status-column--tone-2,
.step-status-cell--tone-2 {
  background: rgba(254, 243, 199, 0.2);
}

.step-status-column--tone-3,
.step-status-cell--tone-3 {
  background: rgba(220, 252, 231, 0.18);
}

.step-status-column--tone-4,
.step-status-cell--tone-4 {
  background: rgba(237, 233, 254, 0.22);
}

.step-status-column--group-start,
.step-status-cell--group-start {
  border-left: 3px solid rgba(148, 163, 184, 0.18);
}

.step-status-column--tone-2.step-status-column--group-start,
.step-status-cell--tone-2.step-status-cell--group-start {
  border-left-color: rgba(245, 158, 11, 0.2);
}

.step-status-column--tone-3.step-status-column--group-start,
.step-status-cell--tone-3.step-status-cell--group-start {
  border-left-color: rgba(34, 197, 94, 0.18);
}

.step-status-column--tone-4.step-status-column--group-start,
.step-status-cell--tone-4.step-status-cell--group-start {
  border-left-color: rgba(109, 40, 217, 0.18);
}

.step-status-column--group-gap,
.step-status-cell--group-gap {
  border-left-width: 18px;
  background-clip: padding-box;
}

.step-status-column--group-end,
.step-status-cell--group-end {
  box-shadow: inset -1px 0 0 rgba(226, 232, 240, 0.92);
}

.step-status-cell {
  padding-left: 6px !important;
  padding-right: 6px !important;
}

.step-status-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
  min-height: 56px;
}

.step-status-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 32px;
  min-width: 0;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #f8fafc;
  color: #334155;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  line-height: 1.1;
  white-space: nowrap;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
  box-sizing: border-box;
}

.step-status-pill > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
}

.step-status-icon {
  font-size: 0.95rem;
  line-height: 1;
  flex: 0 0 auto;
}

.step-status-meta {
  display: block;
  width: 100%;
  min-height: 16px;
  font-size: 0.67rem;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
  text-align: center;
}

.step-status-meta--hidden {
  visibility: hidden;
}

.step-status-pill--done {
  border-color: rgba(34, 197, 94, 0.26);
  background: #ecfdf5;
  color: #15803d;
}

.step-status-pill--info {
  border-color: rgba(59, 130, 246, 0.26);
  background: #eff6ff;
  color: #1d4ed8;
}

.step-status-pill--warning {
  border-color: rgba(245, 158, 11, 0.26);
  background: #fff7ed;
  color: #b45309;
}

.step-status-pill--danger {
  border-color: rgba(239, 68, 68, 0.28);
  background: #fef2f2;
  color: #b91c1c;
}

.step-status-pill--neutral {
  border-color: rgba(148, 163, 184, 0.28);
  background: #f8fafc;
  color: #475569;
}

.step-status-pill--waiting {
  border-color: rgba(148, 163, 184, 0.32);
  background: #f1f5f9;
  color: #475569;
}

.step-status-pill--blocked {
  border-color: rgba(100, 116, 139, 0.35);
  background: #e2e8f0;
  color: #334155;
}

.step-status-pill--na {
  border-color: rgba(203, 213, 225, 0.4);
  background: #f8fafc;
  color: #94a3b8;
}

.step-status-empty {
  min-height: 56px;
}

.actions-cell {
  text-align: center;
  white-space: nowrap;
}

.saved-cell {
  text-align: center;
}

.saved-flag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.32);
  background: #f8fafc;
}

.saved-flag input[type='checkbox'] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #16a34a;
}

.saved-flag input[type='checkbox']:disabled {
  cursor: not-allowed;
}

.saved-flag--saving {
  opacity: 0.6;
}

.saved-flag--saving input[type='checkbox'] {
  cursor: wait;
}

.user-card {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(226, 232, 240, 0.9);
}

.user-card__name-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.user-card__name {
  font-weight: 800;
  line-height: 1.35;
  color: #0f172a;
}

.user-card__email {
  font-size: 0.79rem;
  font-weight: 600;
  color: #475569;
  word-break: break-word;
}

.user-card__program {
  font-size: 0.72rem;
  font-weight: 700;
  color: #1d4ed8;
  line-height: 1.45;
}

.check-cell {
  text-align: center;
}

.tracking-cell-loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
}

.check-date {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 124px;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.88);
}

.check-date__value {
  font-weight: 700;
  color: #0f172a;
}

.check-date__meta {
  font-size: 0.74rem;
  font-weight: 600;
  color: #64748b;
}

.check-diagnostic-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 124px;
  min-height: 76px;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.88);
}

.check-diagnostic-empty {
  color: #94a3b8;
  font-weight: 600;
}

.check-diagnostic-trigger {
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #ffffff;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: help;
  transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.check-diagnostic-trigger:hover,
.check-diagnostic-trigger:focus {
  background: #eef2ff;
  border-color: rgba(99, 102, 241, 0.45);
  color: #4338ca;
  transform: translateY(-1px);
  outline: none;
}

.check-diagnostic-trigger .material-icons {
  font-size: 15px;
}

.check-diagnostic-tooltip {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  min-width: 260px;
  max-width: 320px;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 20px 42px rgba(15, 23, 42, 0.16);
  text-align: left;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(-50%, 8px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
  z-index: 40;
}

.check-diagnostic-tooltip::before {
  content: '';
  position: absolute;
  top: -7px;
  left: 50%;
  width: 14px;
  height: 14px;
  background: #ffffff;
  border-top: 1px solid rgba(148, 163, 184, 0.28);
  border-left: 1px solid rgba(148, 163, 184, 0.28);
  transform: translateX(-50%) rotate(45deg);
}

.check-diagnostic-wrap:hover .check-diagnostic-tooltip,
.check-diagnostic-trigger:focus + .check-diagnostic-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
}

.check-diagnostic-tooltip__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #0f172a;
}

.check-diagnostic-tooltip__line {
  margin-top: 8px;
  font-size: 0.78rem;
  line-height: 1.45;
  color: #475569;
}

.note-cell {
  min-width: 0;
}

.note-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  background: rgba(255, 255, 255, 0.88);
}

.note-input {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: 38px;
  padding: 8px 12px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.38);
  background: rgba(255, 255, 255, 0.96);
  color: #0f172a;
  font-size: 0.88rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.note-input::placeholder {
  color: #94a3b8;
}

.note-input:focus {
  outline: none;
  border-color: rgba(59, 130, 246, 0.58);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.14);
  background: #ffffff;
}

.note-save-status {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
}

.user-cell {
  min-width: 0;
}

.top-order-cell {
  text-align: center;
  white-space: nowrap;
}

.top-order-card {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 132px;
  padding: 10px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.92);
}

.top-order-card--empty {
  min-height: 84px;
  justify-content: center;
  color: #94a3b8;
  font-weight: 700;
}

.top-order-card__meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #64748b;
  line-height: 1.35;
}

.top-order-card__badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px;
  max-width: 138px;
}

.top-order-mini-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #f8fafc;
  color: #475569;
  font-size: 0.64rem;
  font-weight: 800;
  line-height: 1;
}

.top-order-mini-chip--done {
  border-color: rgba(34, 197, 94, 0.25);
  background: #ecfdf5;
  color: #15803d;
}

.top-order-mini-chip--renewed {
  border-color: rgba(59, 130, 246, 0.25);
  background: #eff6ff;
  color: #1d4ed8;
}

.top-order-mini-chip--transition {
  border-color: rgba(147, 51, 234, 0.24);
  background: #faf5ff;
  color: #7e22ce;
}

.top-order-mini-chip--archive {
  border-color: rgba(100, 116, 139, 0.3);
  background: #e2e8f0;
  color: #334155;
}

.top-order-mini-chip--forced {
  border-color: rgba(245, 158, 11, 0.3);
  background: #fff7ed;
  color: #b45309;
}

.top-order-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.36);
  background: #ffffff;
  color: #334155;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.top-order-chip .material-icons {
  font-size: 16px;
}

.buttons-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.buttons-container button {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.3);
  background: #f7f9fc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, color 0.2s ease;
}

.buttons-container button:hover:not(:disabled) {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.6);
  color: #4338ca;
  transform: translateY(-1px);
}

.buttons-container button:disabled {
  cursor: wait;
  opacity: 0.55;
}

.buttons-container .material-icons {
  font-size: 20px;
}

.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 999px;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
}

.status-dot.orange {
  background-color: #f59e0b;
}

.status-dot.green {
  background-color: #22c55e;
}

.status-dot.yellow {
  background-color: #facc15;
}

.empty-state {
  text-align: center;
  color: #64748b;
  font-style: italic;
  padding: 24px !important;
}

.modal {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  z-index: 2000;
  width: 100%;
}

.modal-content {
  position: relative;
  width: min(540px, 92vw);
  max-height: 90vh;
  overflow-y: auto;
  border-radius: 24px;
  padding: 32px 36px;
  background: linear-gradient(180deg, #ffffff 0%, #f5f7fb 100%);
  box-shadow: 0 32px 70px rgba(15, 23, 42, 0.2);
  color: #0f172a;
}

.modal-content h2 {
  margin: 0 0 18px;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color:#0f172a
}

.modal-content form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.modal-content form > div {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modal-content label {
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #475569;
}

.modal-content input,
.modal-content select,
.modal-content textarea {
  width: 100%;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  padding: 12px 14px;
  font-size: 0.96rem;
  color: #0f172a;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.modal-content textarea {
  min-height: 160px;
  resize: vertical;
  line-height: 1.6;
}

.modal-content input:focus,
.modal-content select:focus,
.modal-content textarea:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.65);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.close {
  position: absolute;
  top: 18px;
  right: 18px;
  font-size: 1.4rem;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}

.close:hover {
  color: #64748b;
  transform: scale(1.05);
}

.modal-content button[type="button"] {
  align-self: flex-start;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid rgba(99, 102, 241, 0.4);
  background: #f5f7ff;
  color: #4338ca;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 22px rgba(99, 102, 241, 0.16);
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.modal-content button[type="button"]:hover {
  background: #eef2ff;
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(99, 102, 241, 0.22);
}

.modal-content button[type="submit"] {
  width: 100%;
  padding: 12px 18px;
  border-radius: 16px;
  border: none;
  background: linear-gradient(120deg, #2563eb, #4338ca);
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  box-shadow: 0 20px 38px rgba(37, 99, 235, 0.28);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.modal-content button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 26px 46px rgba(37, 99, 235, 0.35);
}

.message-section {
  margin-top: 18px;
  padding: 18px 20px;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
  box-shadow: 0 18px 32px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message-section h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #1f2937;
}

.message-section pre {
  margin: 0;
  padding: 14px 16px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(148, 163, 184, 0.35);
  font-size: 0.92rem;
  line-height: 1.6;
  color: #0f172a;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 260px;
  overflow: auto;
}

.message-section pre::-webkit-scrollbar {
  width: 8px;
}

.message-section pre::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
}

.message-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.message-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f1f5f9;
  color: #1f2937;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.message-actions button:hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.5);
  color: #4338ca;
  transform: translateY(-1px);
}

.message-actions .copy-button {
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(34, 197, 94, 0.25);
}

.message-actions .copy-button:hover {
  box-shadow: 0 16px 36px rgba(34, 197, 94, 0.32);
}

@media (max-width: 1024px) {
  .toolbar-card {
    padding: 16px;
  }

  .accordion-panel {
    padding: 16px;
    gap: 12px;
  }

  .users-table {
    min-width: 100%;
  }
}

@media (max-width: 640px) {
  .top-monitor-head {
    flex-direction: column;
  }

  .top-list-pagination {
    justify-content: flex-start;
  }

  .top-list-pagination__summary {
    width: 100%;
  }

  .filters-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .filter-field--compact {
    max-width: none;
  }

  .filters-secondary {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-action-button {
    width: 100%;
  }

  .summary-pills {
    min-height: auto;
  }

  .modal-content {
    padding: 28px 22px;
  }

  .message-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .message-actions button,
  .message-actions .copy-button {
    width: 100%;
  }
}
</style>
<style scoped src="../../assets/css/staff-users-top.css"></style>
